
// // import {
// //   Autocomplete,
// //   Box,
// //   Button,
// //   IconButton,
// //   MenuItem,
// //   TextField,
// //   Typography,
// // } from "@mui/material";
// // import { useEffect, useState } from "react";
// // import Grid from "@mui/material/Grid";
// // import AddIcon from '@mui/icons-material/Add';
// // import { useForm } from "react-hook-form";
// // import { useLocation, useNavigate } from "react-router-dom";
// // import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// // import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// // import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// // import SaveIcon from "@mui/icons-material/Save";
// // import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// // import PropaneTankIcon from '@mui/icons-material/PropaneTank';
// // import { useDispatch } from "react-redux";
// // import dayjs from "dayjs";
// // import customerMasterService from "../../../services/masters/customerMaster.Service";
// // import depotMasterService from "../../../services/masters/depotMaster.Service";
// // import productMasterService from "../../../services/masters/productMaster.Service";
// // import uomMasterService from "../../../services/masters/uomMaster.Service";
// // import cylinderMasterService from "../../../services/masters/cylinderMaster.Service";
// // import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
// // import plantmasterservices from "../../../services/masters/plantMaster.Service";
// // import vehiclemasterservices from "../../../services/masters/vehicleMaster.Service";

// // // ── CSS Styles (same as PlantAdd) ──────────────────────────────────────────

// // const pageSx = {
// //   background: "#F4F7FB",
// //   minHeight: "100vh",
// //   padding: "20px 24px 40px",
// //   fontFamily: "'Inter', Arial, sans-serif",
// // };

// // const breadcrumbSx = {
// //   fontSize: "12px",
// //   color: "#718096",
// //   mb: 2,
// //   display: "flex",
// //   alignItems: "center",
// //   gap: "6px",
// // };

// // const pageHeaderSx = {
// //   display: "flex",
// //   alignItems: "center",
// //   justifyContent: "space-between",
// //   mb: 2.5,
// // };

// // const pageTitleSx = {
// //   fontSize: "16px",
// //   fontWeight: 700,
// //   color: "#000000",
// //   display: "flex",
// //   alignItems: "center",
// //   gap: "10px",
// // };

// // const backBtnSx = {
// //   display: "flex",
// //   alignItems: "center",
// //   gap: "6px",
// //   fontSize: "13px",
// //   fontWeight: 600,
// //   color: "#2B6CB0",
// //   padding: "7px 14px",
// //   border: "1.5px solid #2B6CB0",
// //   borderRadius: "7px",
// //   background: "#fff",
// //   cursor: "pointer",
// //   textTransform: "none",
// //   "&:hover": { background: "#E6F1FB" },
// // };

// // const formCardSx = {
// //   background: "#fff",
// //   borderRadius: "14px",
// //   border: "1px solid #E2E8F0",
// //   overflow: "hidden",
// //   mb: 3,
// // };

// // const sectionHeaderSx = {
// //   background: "#1C3A5E",
// //   padding: "12px 22px",
// //   display: "flex",
// //   alignItems: "center",
// //   gap: "10px",
// // };

// // const sectionHeaderTitleSx = {
// //   fontSize: "13px",
// //   fontWeight: 600,
// //   color: "#fff",
// //   letterSpacing: "0.3px",
// // };

// // const formBodySx = { padding: "22px 24px" };

// // const fieldLabelSx = {
// //   fontSize: "12px",
// //   fontWeight: 600,
// //   color: "#2063b6",
// //   mb: "4px",
// //   display: "flex",
// //   alignItems: "center",
// //   gap: "4px",
// // };

// // const inputSx = {
// //   "& .MuiOutlinedInput-root": {
// //     borderRadius: "8px",
// //     fontSize: "13px",
// //     fontFamily: "'Inter', Arial, sans-serif",
// //     background: "#fafafa",
// //     height: "38px",
// //     "& fieldset": { borderColor: "#E2E8F0", borderWidth: "1.5px" },
// //     "&:hover fieldset": { borderColor: "#CBD5E0" },
// //     "&.Mui-focused fieldset": { borderColor: "#2B6CB0", borderWidth: "2px" },
// //     "&.Mui-focused": { background: "#fff" },
// //     "&.Mui-disabled": { background: "#F8FAFC" },
// //   },
// //   "& input": {
// //     color: "#1A202C",
// //     fontSize: "13px",
// //     fontFamily: "'Inter', Arial, sans-serif",
// //     "&::placeholder": { color: "#A0AEC0", opacity: 1 },
// //   },
// //   "& .MuiInputLabel-root": { display: "none" },
// // };

// // const readOnlyInputSx = {
// //   ...inputSx,
// //   "& .MuiOutlinedInput-root": {
// //     ...inputSx["& .MuiOutlinedInput-root"],
// //     background: "#f0f4f8",
// //   },
// // };

// // const subSectionHeaderSx = {
// //   background: "#1C3A5E",
// //   padding: "12px 22px",
// //   display: "flex",
// //   alignItems: "center",
// //   gap: "10px",
// //   borderTop: "1px solid #E2E8F0",
// // };

// // const formFooterSx = {
// //   padding: "18px 24px",
// //   background: "#F8FAFC",
// //   borderTop: "1px solid #E2E8F0",
// //   display: "flex",
// //   alignItems: "center",
// //   justifyContent: "flex-end",
// //   gap: "10px",
// // };

// // const saveBtnSx = {
// //   display: "flex",
// //   alignItems: "center",
// //   gap: "7px",
// //   padding: "0 22px",
// //   height: "40px",
// //   background: "#4CAF50",
// //   color: "#fff",
// //   border: "none",
// //   fontSize: "14px",
// //   fontWeight: 600,
// //   textTransform: "none",
// //   fontFamily: "'Inter', Arial, sans-serif",
// //   "&:hover": { background: "#028b19", transform: "translateY(-1px)" },
// //   "&:active": { transform: "translateY(0)" },
// //   "&.Mui-disabled": { background: "#94a3b8", color: "#fff" },
// //   transition: "all 0.15s ease",
// // };

// // const cancelBtnSx = {
// //   display: "flex",
// //   alignItems: "center",
// //   gap: "7px",
// //   padding: "0 22px",
// //   height: "40px",
// //   background: "#E53E3E",
// //   color: "#ffffff",
// //   border: "none",
// //   "&:hover": { background: "#971f16", transform: "translateY(-1px)" },
// //   fontSize: "14px",
// //   fontWeight: 600,
// //   borderRadius: "8px",
// // };

// // const addIconBtnSx = {
// //   color: "#2B6CB0",
// //   border: "1px solid #2B6CB0",
// //   borderRadius: "6px",
// //   p: "5px",
// //   ml: 0.5,
// //   flexShrink: 0,
// // };

// // // ─────────────────────────────────────────────────────────────────────────────

// // const CylinderAdd = () => {
// //   const { handleSubmit } = useForm({ mode: 'onSubmit' });
// //   const dispatch = useDispatch();
// //   const login_details = sessionStorage.getItem('loginUser');
// //   const userD = JSON.parse(login_details);
// //   const userInfo = userD.result.userInfo;
// //   const urlLocation = useLocation();
// //   const editInfo = urlLocation.state;
// //   const editData = editInfo && editInfo;

// //   const getFileNameFromUrl = (url) => {
// //     try {
// //       const path = new URL(url).pathname;
// //       return path.substring(path.lastIndexOf("/") + 1);
// //     } catch (error) {
// //       return "";
// //     }
// //   };

// //   const [pesoCertificateFile, setPesoCertificateFile] = useState(
// //     editData && editData.peso_certificate_upload
// //       ? { name: getFileNameFromUrl(editData.peso_certificate_upload) } : null
// //   );
// //   const [hydrotestCertificateFile, setHydrotestCertificateFile] = useState(
// //     editData && editData.hydrotest_certificate_upload
// //       ? { name: getFileNameFromUrl(editData.hydrotest_certificate_upload) } : null
// //   );

// //   const [data, setData] = useState({
// //     cylinder_no: editData ? editData.cylinder_no : "",
// //     owner: editData ? editData.owner : "",
// //     prod_id: editData ? editData.prod_id : null,
// //     plant_id: editData ? editData.plant_id : "",
// //     depot_id: editData ? editData.depot_id : "",
// //     prod_code: editData ? editData.prod_code : "",
// //     prod_description: editData ? editData.prod_description : "",
// //     cyl_capacity: editData ? editData.cyl_capacity : "",
// //     uom: editData ? editData.uom : "",
// //     purchase_date: editData?.purchase_date && !isNaN(new Date(editData.purchase_date))
// //       ? new Date(editData.purchase_date).toISOString().split("T")[0]
// //       : new Date().toISOString().split("T")[0],
// //     tare_wt: editData ? editData.tare_wt : "",
// //     water_capacity: editData ? editData.water_capacity : "",
// //     test_pressure: editData ? editData.test_pressure : "",
// //     working_pressure: editData ? editData.working_pressure : "",
// //     cylinder_manufacturer: editData ? editData.cylinder_manufacturer : "",
// //     tag_no: editData ? editData.tag_no : "",
// //     cylinder_manufacturing_code: editData ? editData.cylinder_manufacturing_code : "",
// //     cylinder_manufacturing_date: editData?.cylinder_manufacturing_date && !isNaN(new Date(editData.cylinder_manufacturing_date))
// //       ? new Date(editData.cylinder_manufacturing_date).toISOString().split("T")[0]
// //       : new Date().toISOString().split("T")[0],
// //     cylinder_purchase_date: editData?.cylinder_purchase_date && !isNaN(new Date(editData.cylinder_purchase_date))
// //       ? new Date(editData.cylinder_purchase_date).toISOString().split("T")[0]
// //       : new Date().toISOString().split("T")[0],
// //     valve_type: editData ? editData.valve_type : "",
// //     valve_manufacturer: editData ? editData.valve_manufacturer : "",
// //     valve_manufacturing_code: editData ? editData.valve_manufacturing_code : "",
// //     valve_test_pressure: editData ? editData.valve_test_pressure : "",
// //     valve_working_pressure: editData ? editData.valve_working_pressure : "",
// //     peso_approval_no: editData ? editData.peso_approval_no : "",
// //     peso_approval_date: editData?.peso_approval_date && !isNaN(new Date(editData.peso_approval_date))
// //       ? new Date(editData.peso_approval_date).toISOString().split("T")[0]
// //       : new Date().toISOString().split("T")[0],
// //     peso_certificate_upload: editData ? editData.peso_certificate_upload : "",
// //     hydrotest_certificate_no: editData ? editData.hydrotest_certificate_no : "",
// //     hydrotest_date: editData?.hydrotest_date && !isNaN(new Date(editData.hydrotest_date))
// //       ? new Date(editData.hydrotest_date).toISOString().split("T")[0]
// //       : new Date().toISOString().split("T")[0],
// //     hydrotest_certificate_upload: editData ? editData.hydrotest_certificate_upload : "",
// //     current_location: editData ? editData.current_location : "",
// //     current_plant_id: editData ? editData.current_plant_id : "",
// //     current_vehicle_id: editData ? editData.current_vehicle_id : "",
// //     current_depot_id: editData ? editData.current_depot_id : "",
// //     cust_id: editData ? editData.customer_id : "",
// //     current_customer_id: editData ? editData.current_customer_id : "",
// //     status: editData ? editData.status : "",
// //     note: editData ? editData.note : "",
// //     storage: editData ? editData.storage : "",
// //   });

// //   const [successMessage, setSuccessMessage] = useState(null);
// //   const [customer, setCustomer] = useState([]);
// //   const [depot, setDepot] = useState([]);
// //   const [product, setProduct] = useState([]);
// //   const [uom, setUOM] = useState([]);
// //   const [plant, setPlant] = useState([]);
// //   const [vehicle, setvehicle] = useState([]);

// //   useEffect(() => {
// //     async function fetchData() {
// //       try {
// //         const [customerData, depotData, productData, uomData, plantdata, vehicleData] = await Promise.all([
// //           customerMasterService.getCustomerList({ page: 0, size: 999, searchKey: "" }),
// //           depotMasterService.getDepotList({ page: 0, size: 999, searchKey: "" }),
// //           productMasterService.getProductList({ page: 0, size: 999, searchKey: "" }),
// //           uomMasterService.getUOMList({ page: 0, size: 999, searchKey: "" }),
// //           plantmasterservices.getPlantList({ page: 0, size: 999, searchKey: "" }),
// //           vehiclemasterservices.getVehicleList({ page: 0, size: 999, searchKey: "" }),
// //         ]);
// //         setCustomer(customerData);
// //         setDepot(depotData);
// //         setProduct(productData);
// //         setUOM(uomData);
// //         setPlant(plantdata);
// //         setvehicle(vehicleData);
// //       } catch (error) {
// //         console.error("Data fetching failed", error);
// //       }
// //     }
// //     fetchData();
// //   }, []);

// //   useEffect(() => {
// //     let objectUrlPo, objectUrlQuotation;
// //     if (pesoCertificateFile instanceof File) objectUrlPo = URL.createObjectURL(pesoCertificateFile);
// //     if (hydrotestCertificateFile instanceof File) objectUrlQuotation = URL.createObjectURL(hydrotestCertificateFile);
// //     return () => {
// //       if (objectUrlPo) URL.revokeObjectURL(objectUrlPo);
// //       if (objectUrlQuotation) URL.revokeObjectURL(objectUrlQuotation);
// //     };
// //   }, [pesoCertificateFile, hydrotestCertificateFile]);

// //   const handleChange = ({ target }) => {
// //     const { name, value } = target;
// //     if (name === "prod_code") {
// //       const selectedProduct = product.find((p) => p.prod_code === value);
// //       setData({ ...data, prod_code: value, prod_id: selectedProduct?.prod_id || "", prod_description: selectedProduct?.prod_description || "" });
// //     } else {
// //       setData({ ...data, [name]: value });
// //     }
// //   };

// //   const uploadFile = (e) => {
// //     const file = e.target.files[0];
// //     setPesoCertificateFile(file);
// //     setData((prev) => ({ ...prev, peso_certificate_upload: file ? file.name : "" }));
// //   };

// //   const uploadHydrotestFile = (e) => {
// //     const file = e.target.files[0];
// //     setHydrotestCertificateFile(file);
// //     setData((prev) => ({ ...prev, hydrotest_certificate_upload: file ? file.name : "" }));
// //   };

// //   const navigate = useNavigate();
// //   const handleBack = () => navigate(-1);
// //   const handleNavigate = (path) => navigate(path);

// //   const onSubmit = async () => {
// //     const cylinderData = {
// //       cylinder_no: data.cylinder_no, owner: data.owner, prod_id: data.prod_id,
// //       plant_id: data.plant_id, prod_code: data.prod_code, prod_description: data.prod_description,
// //       cyl_capacity: data.cyl_capacity, uom: data.uom, purchase_date: data.purchase_date,
// //       tare_wt: data.tare_wt, water_capacity: data.water_capacity, test_pressure: data.test_pressure,
// //       working_pressure: data.working_pressure, cylinder_manufacturer: data.cylinder_manufacturer,
// //       tag_no: data.tag_no, cylinder_manufacturing_code: data.cylinder_manufacturing_code,
// //       cylinder_manufacturing_date: data.cylinder_manufacturing_date,
// //       cylinder_purchase_date: data.cylinder_purchase_date, valve_type: data.valve_type,
// //       valve_manufacturer: data.valve_manufacturer, valve_manufacturing_code: data.valve_manufacturing_code,
// //       valve_test_pressure: data.valve_test_pressure, valve_working_pressure: data.valve_working_pressure,
// //       peso_approval_no: data.peso_approval_no, peso_approval_date: data.peso_approval_date,
// //       hydrotest_certificate_no: data.hydrotest_certificate_no, hydrotest_date: data.hydrotest_date,
// //       current_location: data.current_location, current_plant_id: data.current_plant_id,
// //       current_vehicle_id: data.current_vehicle_id, current_depot_id: data.current_depot_id,
// //       current_customer_id: data.current_customer_id, customer_id: data.cust_id,
// //       status: data.status, note: data.note, storage: data.storage,
// //       modified_at: dayjs().format('YYYY-MM-DD HH:mm:ss'),
// //       modified_by: editData ? userInfo.user_id : null,
// //       created_at: dayjs().format('YYYY-MM-DD HH:mm:ss'),
// //       created_by: editData ? editData.created_by : userInfo.user_id,
// //       changedUpdatedValue: "edit",
// //       cyl_id: editData ? editData.cyl_id : "",
// //     };
// //     const formData = new FormData();
// //     formData.append("cylinderData", JSON.stringify(cylinderData));
// //     if (pesoCertificateFile instanceof File) formData.append("peso_certificate_upload", pesoCertificateFile);
// //     else if (editData?.peso_certificate_upload) formData.append("peso_certificate_upload", editData.peso_certificate_upload);
// //     if (hydrotestCertificateFile instanceof File) formData.append("hydrotest_certificate_upload", hydrotestCertificateFile);
// //     else if (editData?.hydrotest_certificate_upload) formData.append("hydrotest_certificate_upload", editData.hydrotest_certificate_upload);
// //     try {
// //       if (editData) {
// //         await cylinderMasterService.editDeleteCylinder(formData);
// //         setSuccessMessage("Updated successfully");
// //       } else {
// //         await cylinderMasterService.addCylinder(formData);
// //         setSuccessMessage("Added successfully");
// //       }
// //       setTimeout(() => { navigate(-1); setSuccessMessage(null); }, 1000);
// //     } catch (error) {
// //       setSuccessMessage(`Error: ${error.message || "An error occurred"}`);
// //     }
// //   };

// //   // Helper for Autocomplete field
// //   const AutocompleteField = ({ label, required, options, getOptionLabel, value, onChange, isOptionEqualToValue, onAddClick, renderOption }) => (
// //     <Box>
// //       <Typography sx={fieldLabelSx}>
// //         {label} {required && <span style={{ color: "#E53E3E" }}>*</span>}
// //       </Typography>
// //       <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
// //         <Autocomplete
// //           options={options || []}
// //           fullWidth
// //           getOptionLabel={getOptionLabel}
// //           value={value}
// //           onChange={onChange}
// //           renderOption={renderOption || ((props, option) => (
// //             <MenuItem {...props} sx={{ fontSize: "13px" }}>{getOptionLabel(option)}</MenuItem>
// //           ))}
// //           renderInput={(params) => (
// //             <TextField {...params} size="small" fullWidth sx={inputSx} required={required} />
// //           )}
// //           isOptionEqualToValue={isOptionEqualToValue}
// //         />
// //         {onAddClick && (
// //           <IconButton size="small" onClick={onAddClick} sx={addIconBtnSx}>
// //             <AddIcon fontSize="small" />
// //           </IconButton>
// //         )}
// //       </Box>
// //     </Box>
// //   );

// //   return (
// //     <LocalizationProvider dateAdapter={AdapterDayjs}>
// //       <Box sx={pageSx}>

// //         {/* Breadcrumb */}
// //         <Box sx={breadcrumbSx}>
// //           <span>Dashboard</span> / <span style={{ color: "#2B6CB0", fontWeight: 600 }}>Cylinder</span>
// //         </Box>

// //         {/* Page Header */}
// //         <Box sx={pageHeaderSx}>
// //           <Box sx={pageTitleSx}>
// //             <PropaneTankIcon sx={{ fontSize: 20, color: "#1C3A5E" }} />
// //             {editData ? "UPDATE" : "ADD"} CYLINDER
// //           </Box>
// //           <Button onClick={handleBack} sx={backBtnSx}>
// //             <ArrowBackIcon sx={{ fontSize: 16 }} /> Back
// //           </Button>
// //         </Box>

// //         <form onSubmit={handleSubmit(onSubmit)}>

// //           {/* ── Section 1: Basic Info ── */}
// //           <Box sx={formCardSx}>
// //             <Box sx={sectionHeaderSx}>
// //               <PropaneTankIcon sx={{ fontSize: 18, color: "#fff" }} />
// //               <Typography sx={sectionHeaderTitleSx}>Basic Information</Typography>
// //             </Box>
// //             <Box sx={formBodySx}>
// //               <Grid container spacing={3}>

// //                 {/* Cylinder No */}
// //                 <Grid item xs={12} md={6}>
// //                   <Box>
// //                     <Typography sx={fieldLabelSx}>Cylinder No <span style={{ color: "#E53E3E" }}>*</span></Typography>
// //                     <TextField size="small" fullWidth type="text" onChange={handleChange}
// //                       name="cylinder_no" value={data.cylinder_no} required sx={inputSx} placeholder="Enter cylinder number" />
// //                   </Box>
// //                 </Grid>

// //                 {/* Cylinder Tag */}
// //                 <Grid item xs={12} md={6}>
// //                   <Box>
// //                     <Typography sx={fieldLabelSx}>Cylinder Tag</Typography>
// //                     <TextField size="small" fullWidth type="text" onChange={handleChange}
// //                       name="tag_no" value={data.tag_no} sx={inputSx} placeholder="Enter tag number" />
// //                   </Box>
// //                 </Grid>

// //                 {/* Owner */}
// //                 <Grid item xs={12} md={6}>
// //                   <Box>
// //                     <Typography sx={fieldLabelSx}>Owner <span style={{ color: "#E53E3E" }}>*</span></Typography>
// //                     <TextField select size="small" fullWidth required onChange={handleChange}
// //                       name="owner" value={data.owner} sx={inputSx}>
// //                       <MenuItem value="TGPL" sx={{ fontSize: "13px" }}>TGPL</MenuItem>
// //                       <MenuItem value="Customer" sx={{ fontSize: "13px" }}>Customer</MenuItem>
// //                     </TextField>
// //                   </Box>
// //                 </Grid>

// //                 {/* Customer Name (conditional) */}
// //                 {data.owner === "Customer" && (
// //                   <Grid item xs={12} md={6}>
// //                     <Box>
// //                       <Typography sx={fieldLabelSx}>Customer Name</Typography>
// //                       <TextField select size="small" fullWidth onChange={handleChange}
// //                         name="cust_id" value={data.cust_id || ""} sx={inputSx}>
// //                         <MenuItem value=""><em>Select Customer</em></MenuItem>
// //                         {customer.map((c) => (
// //                           <MenuItem key={c.cust_id} value={c.cust_id} sx={{ fontSize: "13px" }}>{c.cust_name}</MenuItem>
// //                         ))}
// //                       </TextField>
// //                     </Box>
// //                   </Grid>
// //                 )}

// //                 {/* Plant */}
// //                 <Grid item xs={12} md={6}>
// //                   <AutocompleteField
// //                     label="Plant"
// //                     options={plant}
// //                     getOptionLabel={(o) => o?.plant_name || ""}
// //                     value={plant?.find((i) => String(i.plant_id) === String(data.plant_id)) || null}
// //                     onChange={(e, v) => handleChange({ target: { name: "plant_id", value: v ? v.plant_id : "" } })}
// //                     isOptionEqualToValue={(o, v) => String(o.plant_id) === String(v.plant_id)}
// //                     onAddClick={() => handleNavigate('/masters/Addplant')}
// //                   />
// //                 </Grid>

// //                 {/* Product Code */}
// //                 <Grid item xs={12} md={6}>
// //                   <AutocompleteField
// //                     label="Product Code" required
// //                     options={product}
// //                     getOptionLabel={(o) => o?.prod_code || ""}
// //                     value={product?.find((p) => p.prod_code === data.prod_code) || null}
// //                     onChange={(e, v) => handleChange({ target: { name: "prod_code", value: v ? v.prod_code : "" } })}
// //                     isOptionEqualToValue={(o, v) => o.prod_code === v.prod_code}
// //                   />
// //                 </Grid>

// //                 {/* Product Description (readonly) */}
// //                 <Grid item xs={12} md={6}>
// //                   <Box>
// //                     <Typography sx={fieldLabelSx}>Product Description</Typography>
// //                     <TextField size="small" fullWidth value={data.prod_description}
// //                       sx={readOnlyInputSx} InputProps={{ readOnly: true }} placeholder="Auto-filled from product code" />
// //                   </Box>
// //                 </Grid>

// //                 {/* UOM */}
// //                 <Grid item xs={12} md={6}>
// //                   <AutocompleteField
// //                     label="UOM"
// //                     options={uom}
// //                     getOptionLabel={(o) => o?.uom || ""}
// //                     value={uom?.find((u) => u.uom === data.uom) || null}
// //                     onChange={(e, v) => handleChange({ target: { name: "uom", value: v ? v.uom : "" } })}
// //                     isOptionEqualToValue={(o, v) => o.uom === v.uom}
// //                     onAddClick={() => handleNavigate('/masters/add-uom')}
// //                   />
// //                 </Grid>

// //                 {/* Cylinder Capacity */}
// //                 <Grid item xs={12} md={6}>
// //                   <Box>
// //                     <Typography sx={fieldLabelSx}>Cylinder Capacity (Kg)</Typography>
// //                     <TextField size="small" fullWidth type="text" onChange={handleChange}
// //                       name="cyl_capacity" value={data.cyl_capacity} sx={inputSx} placeholder="Enter capacity" />
// //                   </Box>
// //                 </Grid>

// //                 {/* Tare Wt */}
// //                 <Grid item xs={12} md={6}>
// //                   <Box>
// //                     <Typography sx={fieldLabelSx}>Tare Wt</Typography>
// //                     <TextField size="small" fullWidth type="text" onChange={handleChange}
// //                       name="tare_wt" value={data.tare_wt} sx={inputSx} placeholder="Enter tare weight" />
// //                   </Box>
// //                 </Grid>

// //                 {/* Water Capacity */}
// //                 <Grid item xs={12} md={6}>
// //                   <Box>
// //                     <Typography sx={fieldLabelSx}>Water Capacity</Typography>
// //                     <TextField size="small" fullWidth type="text" onChange={handleChange}
// //                       name="water_capacity" value={data.water_capacity} sx={inputSx} placeholder="Enter water capacity" />
// //                   </Box>
// //                 </Grid>

// //               </Grid>
// //             </Box>

// //             {/* ── Section 2: Specifications ── */}
// //             <Box sx={subSectionHeaderSx}>
// //               <PropaneTankIcon sx={{ fontSize: 18, color: "#fff" }} />
// //               <Typography sx={sectionHeaderTitleSx}>Specifications</Typography>
// //             </Box>
// //             <Box sx={formBodySx}>
// //               <Grid container spacing={3}>

// //                 <Grid item xs={12} md={6}>
// //                   <Box>
// //                     <Typography sx={fieldLabelSx}>Test Pressure</Typography>
// //                     <TextField size="small" fullWidth type="text" onChange={handleChange}
// //                       name="test_pressure" value={data.test_pressure} sx={inputSx} placeholder="Enter test pressure" />
// //                   </Box>
// //                 </Grid>

// //                 <Grid item xs={12} md={6}>
// //                   <Box>
// //                     <Typography sx={fieldLabelSx}>Working Pressure</Typography>
// //                     <TextField size="small" fullWidth type="text" onChange={handleChange}
// //                       name="working_pressure" value={data.working_pressure} sx={inputSx} placeholder="Enter working pressure" />
// //                   </Box>
// //                 </Grid>

// //                 <Grid item xs={12} md={6}>
// //                   <Box>
// //                     <Typography sx={fieldLabelSx}>Cylinder Manufacturer</Typography>
// //                     <TextField size="small" fullWidth type="text" onChange={handleChange}
// //                       name="cylinder_manufacturer" value={data.cylinder_manufacturer} sx={inputSx} placeholder="Enter manufacturer" />
// //                   </Box>
// //                 </Grid>

// //                 <Grid item xs={12} md={6}>
// //                   <Box>
// //                     <Typography sx={fieldLabelSx}>Cylinder Manufacturing Code <span style={{ color: "#E53E3E" }}>*</span></Typography>
// //                     <TextField size="small" fullWidth type="text" onChange={handleChange}
// //                       name="cylinder_manufacturing_code" value={data.cylinder_manufacturing_code} sx={inputSx} placeholder="Enter manufacturing code" />
// //                   </Box>
// //                 </Grid>

// //                 <Grid item xs={12} md={6}>
// //                   <Box>
// //                     <Typography sx={fieldLabelSx}>Cylinder Manufacturing Date</Typography>
// //                     <DatePicker format="DD/MM/YYYY"
// //                       value={data.cylinder_manufacturing_date ? dayjs(data.cylinder_manufacturing_date) : dayjs()}
// //                       onChange={(v) => handleChange({ target: { name: "cylinder_manufacturing_date", value: v ? v.format("YYYY-MM-DD") : "" } })}
// //                       slotProps={{ textField: { size: "small", fullWidth: true, sx: inputSx } }} />
// //                   </Box>
// //                 </Grid>

// //                 <Grid item xs={12} md={6}>
// //                   <Box>
// //                     <Typography sx={fieldLabelSx}>Cylinder Purchase Date</Typography>
// //                     <DatePicker format="DD/MM/YYYY"
// //                       value={data.cylinder_purchase_date ? dayjs(data.cylinder_purchase_date) : null}
// //                       onChange={(v) => handleChange({ target: { name: "cylinder_purchase_date", value: v ? v.format("YYYY-MM-DD") : "" } })}
// //                       slotProps={{ textField: { size: "small", fullWidth: true, sx: inputSx } }} />
// //                   </Box>
// //                 </Grid>

// //                 <Grid item xs={12} md={6}>
// //                   <Box>
// //                     <Typography sx={fieldLabelSx}>Valve Type</Typography>
// //                     <TextField size="small" fullWidth type="text" onChange={handleChange}
// //                       name="valve_type" value={data.valve_type} sx={inputSx} placeholder="Enter valve type" />
// //                   </Box>
// //                 </Grid>

// //                 <Grid item xs={12} md={6}>
// //                   <Box>
// //                     <Typography sx={fieldLabelSx}>Valve Manufacturer</Typography>
// //                     <TextField size="small" fullWidth type="text" onChange={handleChange}
// //                       name="valve_manufacturer" value={data.valve_manufacturer} sx={inputSx} placeholder="Enter valve manufacturer" />
// //                   </Box>
// //                 </Grid>

// //                 <Grid item xs={12} md={6}>
// //                   <Box>
// //                     <Typography sx={fieldLabelSx}>Valve Manufacturing Code</Typography>
// //                     <TextField size="small" fullWidth type="text" onChange={handleChange}
// //                       name="valve_manufacturing_code" value={data.valve_manufacturing_code} sx={inputSx} placeholder="Enter valve manufacturing code" />
// //                   </Box>
// //                 </Grid>

// //                 <Grid item xs={12} md={6}>
// //                   <Box>
// //                     <Typography sx={fieldLabelSx}>Valve Test Pressure</Typography>
// //                     <TextField size="small" fullWidth type="text" onChange={handleChange}
// //                       name="valve_test_pressure" value={data.valve_test_pressure} sx={inputSx} placeholder="Enter valve test pressure" />
// //                   </Box>
// //                 </Grid>

// //                 <Grid item xs={12} md={6}>
// //                   <Box>
// //                     <Typography sx={fieldLabelSx}>Valve Working Pressure</Typography>
// //                     <TextField size="small" fullWidth type="text" onChange={handleChange}
// //                       name="valve_working_pressure" value={data.valve_working_pressure} sx={inputSx} placeholder="Enter valve working pressure" />
// //                   </Box>
// //                 </Grid>

// //               </Grid>
// //             </Box>

// //             {/* ── Section 3: Test & Certifications ── */}
// //             <Box sx={subSectionHeaderSx}>
// //               <PropaneTankIcon sx={{ fontSize: 18, color: "#fff" }} />
// //               <Typography sx={sectionHeaderTitleSx}>Test & Certifications</Typography>
// //             </Box>
// //             <Box sx={formBodySx}>
// //               <Grid container spacing={3}>

// //                 <Grid item xs={12} md={6}>
// //                   <Box>
// //                     <Typography sx={fieldLabelSx}>Peso Approval No</Typography>
// //                     <TextField size="small" fullWidth type="text" onChange={handleChange}
// //                       name="peso_approval_no" value={data.peso_approval_no} sx={inputSx} placeholder="Enter PESO approval number" />
// //                   </Box>
// //                 </Grid>

// //                 <Grid item xs={12} md={6}>
// //                   <Box>
// //                     <Typography sx={fieldLabelSx}>Peso Approval Date</Typography>
// //                     <DatePicker format="DD/MM/YYYY"
// //                       value={data.peso_approval_date ? dayjs(data.peso_approval_date) : dayjs()}
// //                       onChange={(v) => handleChange({ target: { name: "peso_approval_date", value: v ? v.format("YYYY-MM-DD") : "" } })}
// //                       slotProps={{ textField: { size: "small", fullWidth: true, sx: inputSx } }} />
// //                   </Box>
// //                 </Grid>

// //                 <Grid item xs={12} md={6}>
// //                   <Box>
// //                     <Typography sx={fieldLabelSx}>Peso Certificate Upload</Typography>
// //                     <TextField size="small" fullWidth type="file" onChange={uploadFile}
// //                       name="peso_certificate_upload" sx={inputSx}
// //                       InputProps={{ inputProps: { accept: ".pdf,.jpg,.png" } }} />
// //                     {pesoCertificateFile && (
// //                       <Typography sx={{ fontSize: "11px", color: "#718096", mt: 0.5 }}>{pesoCertificateFile.name}</Typography>
// //                     )}
// //                   </Box>
// //                 </Grid>

// //                 <Grid item xs={12} md={6}>
// //                   <Box>
// //                     <Typography sx={fieldLabelSx}>Hydrotest Certificate No</Typography>
// //                     <TextField size="small" fullWidth type="text" onChange={handleChange}
// //                       name="hydrotest_certificate_no" value={data.hydrotest_certificate_no} sx={inputSx} placeholder="Enter hydrotest certificate number" />
// //                   </Box>
// //                 </Grid>

// //                 <Grid item xs={12} md={6}>
// //                   <Box>
// //                     <Typography sx={fieldLabelSx}>Hydrotest Date</Typography>
// //                     <DatePicker format="DD/MM/YYYY"
// //                       value={data.hydrotest_date ? dayjs(data.hydrotest_date) : dayjs()}
// //                       onChange={(v) => handleChange({ target: { name: "hydrotest_date", value: v ? v.format("YYYY-MM-DD") : "" } })}
// //                       slotProps={{ textField: { size: "small", fullWidth: true, sx: inputSx } }} />
// //                   </Box>
// //                 </Grid>

// //                 <Grid item xs={12} md={6}>
// //                   <Box>
// //                     <Typography sx={fieldLabelSx}>Hydrotest Certificate Upload</Typography>
// //                     <TextField size="small" fullWidth type="file" onChange={uploadHydrotestFile}
// //                       name="hydrotest_certificate_upload" sx={inputSx}
// //                       InputProps={{ inputProps: { accept: ".pdf,.jpg,.png" } }} />
// //                     {hydrotestCertificateFile && (
// //                       <Typography sx={{ fontSize: "11px", color: "#718096", mt: 0.5 }}>{hydrotestCertificateFile.name}</Typography>
// //                     )}
// //                   </Box>
// //                 </Grid>

// //               </Grid>
// //             </Box>

// //             {/* ── Section 4: Current Location ── */}
// //             <Box sx={subSectionHeaderSx}>
// //               <PropaneTankIcon sx={{ fontSize: 18, color: "#fff" }} />
// //               <Typography sx={sectionHeaderTitleSx}>Current Location & Status</Typography>
// //             </Box>
// //             <Box sx={formBodySx}>
// //               <Grid container spacing={3}>

// //                 <Grid item xs={12} md={6}>
// //                   <Box>
// //                     <Typography sx={fieldLabelSx}>Current Location</Typography>
// //                     <TextField select size="small" fullWidth onChange={handleChange}
// //                       name="current_location" value={data.current_location} sx={inputSx}>
// //                       <MenuItem value=""><em>None</em></MenuItem>
// //                       <MenuItem value="Customer" sx={{ fontSize: "13px" }}>Customer</MenuItem>
// //                       <MenuItem value="Plant" sx={{ fontSize: "13px" }}>Plant</MenuItem>
// //                       <MenuItem value="Depot" sx={{ fontSize: "13px" }}>Depot</MenuItem>
// //                       <MenuItem value="Vehicle" sx={{ fontSize: "13px" }}>Vehicle</MenuItem>
// //                     </TextField>
// //                   </Box>
// //                 </Grid>

// //                 {data.current_location === "Depot" && (
// //                   <Grid item xs={12} md={6}>
// //                     <AutocompleteField
// //                       label="Depot"
// //                       options={depot}
// //                       getOptionLabel={(o) => o?.depot_name || ""}
// //                       value={depot?.find((i) => String(i.depot_id) === String(data.current_depot_id)) || null}
// //                       onChange={(e, v) => handleChange({ target: { name: "current_depot_id", value: v ? v.depot_id : "" } })}
// //                       isOptionEqualToValue={(o, v) => String(o.depot_id) === String(v.depot_id)}
// //                     />
// //                   </Grid>
// //                 )}

// //                 {data.current_location === "Plant" && (
// //                   <Grid item xs={12} md={6}>
// //                     <AutocompleteField
// //                       label="Plant"
// //                       options={plant}
// //                       getOptionLabel={(o) => o?.plant_name || ""}
// //                       value={plant?.find((i) => String(i.plant_id) === String(data.current_plant_id)) || null}
// //                       onChange={(e, v) => handleChange({ target: { name: "current_plant_id", value: v ? v.plant_id : "" } })}
// //                       isOptionEqualToValue={(o, v) => String(o.plant_id) === String(v.plant_id)}
// //                     />
// //                   </Grid>
// //                 )}

// //                 {data.current_location === "Customer" && (
// //                   <Grid item xs={12} md={6}>
// //                     <AutocompleteField
// //                       label="Customer"
// //                       options={customer}
// //                       getOptionLabel={(o) => o?.cust_name || ""}
// //                       value={customer?.find((i) => String(i.cust_id) === String(data.current_customer_id)) || null}
// //                       onChange={(e, v) => handleChange({ target: { name: "current_customer_id", value: v ? v.cust_id : "" } })}
// //                       isOptionEqualToValue={(o, v) => String(o.cust_id) === String(v.cust_id)}
// //                     />
// //                   </Grid>
// //                 )}

// //                 {data.current_location === "Vehicle" && (
// //                   <Grid item xs={12} md={6}>
// //                     <AutocompleteField
// //                       label="Vehicle"
// //                       options={vehicle}
// //                       getOptionLabel={(o) => o?.vehicle_no || ""}
// //                       value={vehicle?.find((i) => String(i.vehicle_id) === String(data.current_vehicle_id)) || null}
// //                       onChange={(e, v) => handleChange({ target: { name: "current_vehicle_id", value: v ? v.vehicle_id : "" } })}
// //                       isOptionEqualToValue={(o, v) => String(o.vehicle_id) === String(v.vehicle_id)}
// //                     />
// //                   </Grid>
// //                 )}

// //                 <Grid item xs={12} md={6}>
// //                   <Box>
// //                     <Typography sx={fieldLabelSx}>Storage</Typography>
// //                     <TextField select size="small" fullWidth onChange={handleChange}
// //                       name="storage" value={data.storage} sx={inputSx}>
// //                       <MenuItem value=""></MenuItem>
// //                       <MenuItem value="Empty Store" sx={{ fontSize: "13px" }}>Empty Store</MenuItem>
// //                       <MenuItem value="Fog Store" sx={{ fontSize: "13px" }}>Fog Store</MenuItem>
// //                       <MenuItem value="Production Bay" sx={{ fontSize: "13px" }}>Production Bay</MenuItem>
// //                       <MenuItem value="Inspection Bay" sx={{ fontSize: "13px" }}>Inspection Bay</MenuItem>
// //                       <MenuItem value="Maintenance Yard" sx={{ fontSize: "13px" }}>Maintenance Yard</MenuItem>
// //                     </TextField>
// //                   </Box>
// //                 </Grid>

// //                 <Grid item xs={12} md={6}>
// //                   <Box>
// //                     <Typography sx={fieldLabelSx}>Status</Typography>
// //                     <TextField select size="small" fullWidth onChange={handleChange}
// //                       name="status" value={data.status} sx={inputSx}>
// //                       <MenuItem value=""></MenuItem>
// //                       <MenuItem value="Empty" sx={{ fontSize: "13px" }}>Empty</MenuItem>
// //                       <MenuItem value="Full" sx={{ fontSize: "13px" }}>Full</MenuItem>
// //                     </TextField>
// //                   </Box>
// //                 </Grid>

// //                 <Grid item xs={12} md={6}>
// //                   <Box>
// //                     <Typography sx={fieldLabelSx}>Note</Typography>
// //                     <TextField select size="small" fullWidth onChange={handleChange}
// //                       name="note" value={data.note} sx={inputSx}>
// //                       <MenuItem value=""></MenuItem>
// //                       <MenuItem value="OK" sx={{ fontSize: "13px" }}>OK</MenuItem>
// //                       <MenuItem value="Not OK" sx={{ fontSize: "13px" }}>Not OK</MenuItem>
// //                     </TextField>
// //                   </Box>
// //                 </Grid>

// //               </Grid>
// //             </Box>

// //             {/* Form Footer */}
// //             <Box sx={formFooterSx}>
// //               <Button sx={cancelBtnSx} onClick={handleBack}>Cancel</Button>
// //               <Button type="submit" sx={saveBtnSx}>
// //                 <SaveIcon sx={{ fontSize: 18 }} />
// //                 {editData ? "Update" : "Save"}
// //               </Button>
// //             </Box>
// //           </Box>
// //         </form>

// //         <ReusableSnackbar
// //           open={!!successMessage}
// //           onClose={(event, reason) => { if (reason !== 'clickaway') setSuccessMessage(""); }}
// //           message={successMessage}
// //           autoHideDuration={2000}
// //           vertical="top"
// //           horizontal="right"
// //         />
// //       </Box>
// //     </LocalizationProvider>
// //   );
// // };

// // export default CylinderAdd;


// import {
//   Autocomplete,
//   Box,
//   Button,
//   IconButton,
//   MenuItem,
//   TextField,
//   Typography,
// } from "@mui/material";
// import { useEffect, useState } from "react";
// import Grid from "@mui/material/Grid";
// import AddIcon from '@mui/icons-material/Add';
// import { useForm } from "react-hook-form";
// import { useLocation, useNavigate } from "react-router-dom";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import SaveIcon from "@mui/icons-material/Save";
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import PropaneTankIcon from '@mui/icons-material/PropaneTank';
// import { useDispatch } from "react-redux";
// import dayjs from "dayjs";
// import customerMasterService from "../../../services/masters/customerMaster.Service";
// import depotMasterService from "../../../services/masters/depotMaster.Service";
// import productMasterService from "../../../services/masters/productMaster.Service";
// import uomMasterService from "../../../services/masters/uomMaster.Service";
// import cylinderMasterService from "../../../services/masters/cylinderMaster.Service";
// import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
// import plantmasterservices from "../../../services/masters/plantMaster.Service";
// import vehiclemasterservices from "../../../services/masters/vehicleMaster.Service";

// // ── Styles ─────────────────────────────────────────────────────────────────

// const pageSx = {
//   background: "#F4F7FB",
//   minHeight: "100vh",
//   padding: "20px 24px 40px",
//   fontFamily: "'Inter', Arial, sans-serif",
// };

// const breadcrumbSx = {
//   fontSize: "12px",
//   color: "#718096",
//   mb: 2,
//   display: "flex",
//   alignItems: "center",
//   gap: "6px",
// };

// const pageHeaderSx = {
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "space-between",
//   mb: 2.5,
// };

// const pageTitleSx = {
//   fontSize: "16px",
//   fontWeight: 700,
//   color: "#000000",
//   display: "flex",
//   alignItems: "center",
//   gap: "10px",
// };

// const backBtnSx = {
//   display: "flex",
//   alignItems: "center",
//   gap: "6px",
//   fontSize: "13px",
//   fontWeight: 600,
//   color: "#2B6CB0",
//   padding: "7px 14px",
//   border: "1.5px solid #2B6CB0",
//   borderRadius: "7px",
//   background: "#fff",
//   cursor: "pointer",
//   textTransform: "none",
//   "&:hover": { background: "#E6F1FB" },
// };

// const formCardSx = {
//   background: "#fff",

//   border: "1px solid #E2E8F0",
//   overflow: "hidden",
//   mb: 3,
// };

// const sectionHeaderSx = {
//   background: "#1C3A5E",
//   padding: "12px 22px",
//   display: "flex",
//   alignItems: "center",
//   gap: "10px",
// };

// const sectionHeaderTitleSx = {
//   fontSize: "13px",
//   fontWeight: 600,
//   color: "#fff",
//   letterSpacing: "0.3px",
// };

// const formBodySx = { padding: "22px 24px" };

// const fieldLabelSx = {
//   fontSize: "12px",
//   fontWeight: 600,
//   color: "#2063b6",
//   mb: "4px",
//   display: "flex",
//   alignItems: "center",
//   gap: "4px",
// };

// const inputSx = {
//   "& .MuiOutlinedInput-root": {
//     borderRadius: "8px",
//     fontSize: "13px",
//     fontFamily: "'Inter', Arial, sans-serif",
//     background: "#fafafa",
//     height: "38px",
//     "& fieldset": { borderColor: "#E2E8F0", borderWidth: "1.5px" },
//     "&:hover fieldset": { borderColor: "#CBD5E0" },
//     "&.Mui-focused fieldset": { borderColor: "#2B6CB0", borderWidth: "2px" },
//     "&.Mui-focused": { background: "#fff" },
//     "&.Mui-disabled": { background: "#F8FAFC" },
//   },
//   "& input": {
//     color: "#1A202C",
//     fontSize: "13px",
//     fontFamily: "'Inter', Arial, sans-serif",
//     "&::placeholder": { color: "#A0AEC0", opacity: 1 },
//   },
//   "& .MuiInputLabel-root": { display: "none" },
// };

// const readOnlyInputSx = {
//   ...inputSx,
//   "& .MuiOutlinedInput-root": {
//     ...inputSx["& .MuiOutlinedInput-root"],
//     background: "#f0f4f8",
//   },
// };

// const formFooterSx = {
//   padding: "18px 24px",
//   background: "#F8FAFC",
//   borderTop: "1px solid #E2E8F0",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "flex-end",
//   gap: "10px",
// };

// const saveBtnSx = {
//   display: "flex",
//   alignItems: "center",
//   gap: "7px",
//   padding: "0 22px",
//   height: "40px",
//   background: "#4CAF50",
//   color: "#fff",
//   border: "none",
//   fontSize: "14px",
//   fontWeight: 600,
//   textTransform: "none",
//   fontFamily: "'Inter', Arial, sans-serif",
//   "&:hover": { background: "#028b19", transform: "translateY(-1px)" },
//   "&:active": { transform: "translateY(0)" },
//   "&.Mui-disabled": { background: "#94a3b8", color: "#fff" },
//   transition: "all 0.15s ease",
// };

// const cancelBtnSx = {
//   display: "flex",
//   alignItems: "center",
//   gap: "7px",
//   padding: "0 22px",
//   height: "40px",
//   background: "#E53E3E",
//   color: "#ffffff",
//   border: "none",
//   "&:hover": { background: "#971f16", transform: "translateY(-1px)" },
//   fontSize: "14px",
//   fontWeight: 600,
//   borderRadius: "8px",
// };

// const addIconBtnSx = {
//   color: "#2B6CB0",
//   border: "1px solid #2B6CB0",
//   borderRadius: "6px",
//   p: "5px",
//   ml: 0.5,
//   flexShrink: 0,
// };

// // ─────────────────────────────────────────────────────────────────────────────

// const CylinderAdd = () => {
//   const { handleSubmit } = useForm({ mode: 'onSubmit' });
//   const dispatch = useDispatch();
//   const login_details = sessionStorage.getItem('loginUser');
//   const userD = JSON.parse(login_details);
//   const userInfo = userD.result.userInfo;
//   const urlLocation = useLocation();
//   const editInfo = urlLocation.state;
//   const editData = editInfo && editInfo;

//   const getFileNameFromUrl = (url) => {
//     try {
//       const path = new URL(url).pathname;
//       return path.substring(path.lastIndexOf("/") + 1);
//     } catch (error) {
//       return "";
//     }
//   };

//   const [pesoCertificateFile, setPesoCertificateFile] = useState(
//     editData && editData.peso_certificate_upload
//       ? { name: getFileNameFromUrl(editData.peso_certificate_upload) } : null
//   );
//   const [hydrotestCertificateFile, setHydrotestCertificateFile] = useState(
//     editData && editData.hydrotest_certificate_upload
//       ? { name: getFileNameFromUrl(editData.hydrotest_certificate_upload) } : null
//   );

//   const [data, setData] = useState({
//     cylinder_no: editData ? editData.cylinder_no : "",
//     owner: editData ? editData.owner : "",
//     prod_id: editData ? editData.prod_id : null,
//     plant_id: editData ? editData.plant_id : "",
//     depot_id: editData ? editData.depot_id : "",
//     prod_code: editData ? editData.prod_code : "",
//     prod_description: editData ? editData.prod_description : "",
//     cyl_capacity: editData ? editData.cyl_capacity : "",
//     uom: editData ? editData.uom : "",
//     purchase_date: editData?.purchase_date && !isNaN(new Date(editData.purchase_date))
//       ? new Date(editData.purchase_date).toISOString().split("T")[0]
//       : new Date().toISOString().split("T")[0],
//     tare_wt: editData ? editData.tare_wt : "",
//     water_capacity: editData ? editData.water_capacity : "",
//     test_pressure: editData ? editData.test_pressure : "",
//     working_pressure: editData ? editData.working_pressure : "",
//     cylinder_manufacturer: editData ? editData.cylinder_manufacturer : "",
//     tag_no: editData ? editData.tag_no : "",
//     cylinder_manufacturing_code: editData ? editData.cylinder_manufacturing_code : "",
//     cylinder_manufacturing_date: editData?.cylinder_manufacturing_date && !isNaN(new Date(editData.cylinder_manufacturing_date))
//       ? new Date(editData.cylinder_manufacturing_date).toISOString().split("T")[0]
//       : new Date().toISOString().split("T")[0],
//     cylinder_purchase_date: editData?.cylinder_purchase_date && !isNaN(new Date(editData.cylinder_purchase_date))
//       ? new Date(editData.cylinder_purchase_date).toISOString().split("T")[0]
//       : new Date().toISOString().split("T")[0],
//     valve_type: editData ? editData.valve_type : "",
//     valve_manufacturer: editData ? editData.valve_manufacturer : "",
//     valve_manufacturing_code: editData ? editData.valve_manufacturing_code : "",
//     valve_test_pressure: editData ? editData.valve_test_pressure : "",
//     valve_working_pressure: editData ? editData.valve_working_pressure : "",
//     peso_approval_no: editData ? editData.peso_approval_no : "",
//     peso_approval_date: editData?.peso_approval_date && !isNaN(new Date(editData.peso_approval_date))
//       ? new Date(editData.peso_approval_date).toISOString().split("T")[0]
//       : new Date().toISOString().split("T")[0],
//     peso_certificate_upload: editData ? editData.peso_certificate_upload : "",
//     hydrotest_certificate_no: editData ? editData.hydrotest_certificate_no : "",
//     hydrotest_date: editData?.hydrotest_date && !isNaN(new Date(editData.hydrotest_date))
//       ? new Date(editData.hydrotest_date).toISOString().split("T")[0]
//       : new Date().toISOString().split("T")[0],
//     hydrotest_certificate_upload: editData ? editData.hydrotest_certificate_upload : "",
//     current_location: editData ? editData.current_location : "",
//     current_plant_id: editData ? editData.current_plant_id : "",
//     current_vehicle_id: editData ? editData.current_vehicle_id : "",
//     current_depot_id: editData ? editData.current_depot_id : "",
//     cust_id: editData ? editData.customer_id : "",
//     current_customer_id: editData ? editData.current_customer_id : "",
//     status: editData ? editData.status : "",
//   level: editData ? (editData.level ?? editData.note ?? "") : "",
// result: editData ? editData.result ?? null : null,
// remark: editData ? editData.remark ?? null : null,
// note: editData ? (editData.level ?? editData.note ?? "") : "",
//     storage: editData ? editData.storage : "",
//   });

//   const [successMessage, setSuccessMessage] = useState(null);
//   const [customer, setCustomer] = useState([]);
//   const [depot, setDepot] = useState([]);
//   const [product, setProduct] = useState([]);
//   const [uom, setUOM] = useState([]);
//   const [plant, setPlant] = useState([]);
//   const [vehicle, setvehicle] = useState([]);

//   useEffect(() => {
//     async function fetchData() {
//       try {
//         const [customerData, depotData, productData, uomData, plantdata, vehicleData] = await Promise.all([
//           customerMasterService.getCustomerList({ page: 0, size: 999, searchKey: "" }),
//           depotMasterService.getDepotList({ page: 0, size: 999, searchKey: "" }),
//           productMasterService.getProductList({ page: 0, size: 999, searchKey: "" }),
//           uomMasterService.getUOMList({ page: 0, size: 999, searchKey: "" }),
//           plantmasterservices.getPlantList({ page: 0, size: 999, searchKey: "" }),
//           vehiclemasterservices.getVehicleList({ page: 0, size: 999, searchKey: "" }),
//         ]);
//         setCustomer(customerData);
//         setDepot(depotData);
//         setProduct(productData);
//         setUOM(uomData);
//         setPlant(plantdata);
//         setvehicle(vehicleData);
//       } catch (error) {
//         console.error("Data fetching failed", error);
//       }
//     }
//     fetchData();
//   }, []);

//   useEffect(() => {
//     let objectUrlPo, objectUrlQuotation;
//     if (pesoCertificateFile instanceof File) objectUrlPo = URL.createObjectURL(pesoCertificateFile);
//     if (hydrotestCertificateFile instanceof File) objectUrlQuotation = URL.createObjectURL(hydrotestCertificateFile);
//     return () => {
//       if (objectUrlPo) URL.revokeObjectURL(objectUrlPo);
//       if (objectUrlQuotation) URL.revokeObjectURL(objectUrlQuotation);
//     };
//   }, [pesoCertificateFile, hydrotestCertificateFile]);

//   const handleChange = ({ target }) => {
//     const { name, value } = target;
//     if (name === "prod_code") {
//       const selectedProduct = product.find((p) => p.prod_code === value);
//       setData({ ...data, prod_code: value, prod_id: selectedProduct?.prod_id || "", prod_description: selectedProduct?.prod_description || "" });
//     } else {
//       setData({ ...data, [name]: value });
//     }
//   };

//   const uploadFile = (e) => {
//     const file = e.target.files[0];
//     setPesoCertificateFile(file);
//     setData((prev) => ({ ...prev, peso_certificate_upload: file ? file.name : "" }));
//   };

//   const uploadHydrotestFile = (e) => {
//     const file = e.target.files[0];
//     setHydrotestCertificateFile(file);
//     setData((prev) => ({ ...prev, hydrotest_certificate_upload: file ? file.name : "" }));
//   };

//   const navigate = useNavigate();
//   const handleBack = () => navigate(-1);
//   const handleNavigate = (path) => navigate(path);

//   const onSubmit = async () => {
//     const cylinderData = {
//       cylinder_no: data.cylinder_no, owner: data.owner, prod_id: data.prod_id,
//       plant_id: data.plant_id, prod_code: data.prod_code, prod_description: data.prod_description,
//       cyl_capacity: data.cyl_capacity, uom: data.uom, purchase_date: data.purchase_date,
//       tare_wt: data.tare_wt, water_capacity: data.water_capacity, test_pressure: data.test_pressure,
//       working_pressure: data.working_pressure, cylinder_manufacturer: data.cylinder_manufacturer,
//       tag_no: data.tag_no, cylinder_manufacturing_code: data.cylinder_manufacturing_code,
//       cylinder_manufacturing_date: data.cylinder_manufacturing_date,
//       cylinder_purchase_date: data.cylinder_purchase_date, valve_type: data.valve_type,
//       valve_manufacturer: data.valve_manufacturer, valve_manufacturing_code: data.valve_manufacturing_code,
//       valve_test_pressure: data.valve_test_pressure, valve_working_pressure: data.valve_working_pressure,
//       peso_approval_no: data.peso_approval_no, peso_approval_date: data.peso_approval_date,
//       hydrotest_certificate_no: data.hydrotest_certificate_no, hydrotest_date: data.hydrotest_date,
//       current_location: data.current_location, current_plant_id: data.current_plant_id,
//       current_vehicle_id: data.current_vehicle_id, current_depot_id: data.current_depot_id,
//       current_customer_id: data.current_customer_id, customer_id: data.cust_id,
//       status: data.status, note: data.note, storage: data.storage,
//       modified_at: dayjs().format('YYYY-MM-DD HH:mm:ss'),
//       modified_by: editData ? userInfo.user_id : null,
//       created_at: dayjs().format('YYYY-MM-DD HH:mm:ss'),
//       created_by: editData ? editData.created_by : userInfo.user_id,
//       changedUpdatedValue: "edit",
//       cyl_id: editData ? editData.cyl_id : "",
//     };
//     const formData = new FormData();
//     formData.append("cylinderData", JSON.stringify(cylinderData));
//     if (pesoCertificateFile instanceof File) formData.append("peso_certificate_upload", pesoCertificateFile);
//     else if (editData?.peso_certificate_upload) formData.append("peso_certificate_upload", editData.peso_certificate_upload);
//     if (hydrotestCertificateFile instanceof File) formData.append("hydrotest_certificate_upload", hydrotestCertificateFile);
//     else if (editData?.hydrotest_certificate_upload) formData.append("hydrotest_certificate_upload", editData.hydrotest_certificate_upload);
//     try {
//       if (editData) {
//         await cylinderMasterService.editDeleteCylinder(formData);
//         setSuccessMessage("Updated successfully");
//       } else {
//         await cylinderMasterService.addCylinder(formData);
//         setSuccessMessage("Added successfully");
//       }
//       setTimeout(() => { navigate(-1); setSuccessMessage(null); }, 1000);
//     } catch (error) {
//       setSuccessMessage(`Error: ${error.message || "An error occurred"}`);
//     }
//   };

//   const AutocompleteField = ({ label, required, options, getOptionLabel, value, onChange, isOptionEqualToValue, onAddClick, renderOption }) => (
//     <Box>
//       <Typography sx={fieldLabelSx}>
//         {label} {required && <span style={{ color: "#E53E3E" }}>*</span>}
//       </Typography>
//       <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
//         <Autocomplete
//           options={options || []}
//           fullWidth
//           getOptionLabel={getOptionLabel}
//           value={value}
//           onChange={onChange}
//           renderOption={renderOption || ((props, option) => (
//             <MenuItem {...props} sx={{ fontSize: "13px" }}>{getOptionLabel(option)}</MenuItem>
//           ))}
//           renderInput={(params) => (
//             <TextField {...params} size="small" fullWidth sx={inputSx} required={required} />
//           )}
//           isOptionEqualToValue={isOptionEqualToValue}
//         />
//         {onAddClick && (
//           <IconButton size="small" onClick={onAddClick} sx={addIconBtnSx}>
//             <AddIcon fontSize="small" />
//           </IconButton>
//         )}
//       </Box>
//     </Box>
//   );

//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <Box sx={pageSx}>

//         {/* Breadcrumb */}
//         <Box sx={breadcrumbSx}>
//           <span>Dashboard</span> / <span style={{ color: "#2B6CB0", fontWeight: 600 }}>Cylinder</span>
//         </Box>

//         {/* Page Header */}
//         <Box sx={pageHeaderSx}>
//           <Box sx={pageTitleSx}>
//             <PropaneTankIcon sx={{ fontSize: 20, color: "#1C3A5E" }} />
//             {editData ? "UPDATE" : "ADD"} CYLINDER
//           </Box>
//           <Button onClick={handleBack} sx={backBtnSx}>
//             <ArrowBackIcon sx={{ fontSize: 16 }} /> Back
//           </Button>
//         </Box>

//         <form onSubmit={handleSubmit(onSubmit)}>

//           {/* ── Single merged card ── */}
//           <Box sx={formCardSx}>

//             {/* Single heading */}
//             <Box sx={sectionHeaderSx}>
//               <PropaneTankIcon sx={{ fontSize: 18, color: "#fff" }} />
//               <Typography sx={sectionHeaderTitleSx}>Cylinder Details</Typography>
//             </Box>

//             {/* All fields in one flat body */}
//             <Box sx={formBodySx}>
//               <Grid container spacing={3}>

//                 {/* Cylinder No */}
//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Cylinder No <span style={{ color: "#E53E3E" }}>*</span></Typography>
//                     <TextField size="small" fullWidth type="text" onChange={handleChange}
//                       name="cylinder_no" value={data.cylinder_no} required sx={inputSx} placeholder="Enter cylinder number" />
//                   </Box>
//                 </Grid>

//                 {/* Cylinder Tag */}
//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Cylinder Tag</Typography>
//                     <TextField size="small" fullWidth type="text" onChange={handleChange}
//                       name="tag_no" value={data.tag_no} sx={inputSx} placeholder="Enter tag number" />
//                   </Box>
//                 </Grid>

//                 {/* Owner */}
//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Owner <span style={{ color: "#E53E3E" }}>*</span></Typography>
//                     <TextField select size="small" fullWidth required onChange={handleChange}
//                       name="owner" value={data.owner} sx={inputSx}>
//                       <MenuItem value="TGPL" sx={{ fontSize: "13px" }}>TGPL</MenuItem>
//                       <MenuItem value="Customer" sx={{ fontSize: "13px" }}>Customer</MenuItem>
//                     </TextField>
//                   </Box>
//                 </Grid>

//                 {/* Customer Name (conditional) */}
//                 {data.owner === "Customer" && (
//                   <Grid item xs={12} md={6}>
//                     <Box>
//                       <Typography sx={fieldLabelSx}>Customer Name</Typography>
//                       <TextField select size="small" fullWidth onChange={handleChange}
//                         name="cust_id" value={data.cust_id || ""} sx={inputSx}>
//                         <MenuItem value=""><em>Select Customer</em></MenuItem>
//                         {customer.map((c) => (
//                           <MenuItem key={c.cust_id} value={c.cust_id} sx={{ fontSize: "13px" }}>{c.cust_name}</MenuItem>
//                         ))}
//                       </TextField>
//                     </Box>
//                   </Grid>
//                 )}

//                 {/* Plant */}
//                 <Grid item xs={12} md={6}>
//                   <AutocompleteField
//                     label="Plant"
//                     options={plant}
//                     getOptionLabel={(o) => o?.plant_name || ""}
//                     value={plant?.find((i) => String(i.plant_id) === String(data.plant_id)) || null}
//                     onChange={(e, v) => handleChange({ target: { name: "plant_id", value: v ? v.plant_id : "" } })}
//                     isOptionEqualToValue={(o, v) => String(o.plant_id) === String(v.plant_id)}
//                     onAddClick={() => handleNavigate('/masters/Addplant')}
//                   />
//                 </Grid>

//                 {/* Product Code */}
//                 <Grid item xs={12} md={6}>
//                   <AutocompleteField
//                     label="Product Code" required
//                     options={product}
//                     getOptionLabel={(o) => o?.prod_code || ""}
//                     value={product?.find((p) => p.prod_code === data.prod_code) || null}
//                     onChange={(e, v) => handleChange({ target: { name: "prod_code", value: v ? v.prod_code : "" } })}
//                     isOptionEqualToValue={(o, v) => o.prod_code === v.prod_code}
//                   />
//                 </Grid>

//                 {/* Product Description */}
//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Product Description</Typography>
//                     <TextField size="small" fullWidth value={data.prod_description}
//                       sx={readOnlyInputSx} InputProps={{ readOnly: true }} placeholder="Auto-filled from product code" />
//                   </Box>
//                 </Grid>

//                 {/* UOM */}
//                 <Grid item xs={12} md={6}>
//                   <AutocompleteField
//                     label="UOM"
//                     options={uom}
//                     getOptionLabel={(o) => o?.uom || ""}
//                     value={uom?.find((u) => u.uom === data.uom) || null}
//                     onChange={(e, v) => handleChange({ target: { name: "uom", value: v ? v.uom : "" } })}
//                     isOptionEqualToValue={(o, v) => o.uom === v.uom}
//                     onAddClick={() => handleNavigate('/masters/add-uom')}
//                   />
//                 </Grid>

//                 {/* Cylinder Capacity */}
//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Cylinder Capacity (Kg)</Typography>
//                     <TextField size="small" fullWidth type="text" onChange={handleChange}
//                       name="cyl_capacity" value={data.cyl_capacity} sx={inputSx} placeholder="Enter capacity" />
//                   </Box>
//                 </Grid>

//                 {/* Tare Wt */}
//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Tare Wt</Typography>
//                     <TextField size="small" fullWidth type="text" onChange={handleChange}
//                       name="tare_wt" value={data.tare_wt} sx={inputSx} placeholder="Enter tare weight" />
//                   </Box>
//                 </Grid>

//                 {/* Water Capacity */}
//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Water Capacity</Typography>
//                     <TextField size="small" fullWidth type="text" onChange={handleChange}
//                       name="water_capacity" value={data.water_capacity} sx={inputSx} placeholder="Enter water capacity" />
//                   </Box>
//                 </Grid>

//                 {/* Test Pressure */}
//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Test Pressure</Typography>
//                     <TextField size="small" fullWidth type="text" onChange={handleChange}
//                       name="test_pressure" value={data.test_pressure} sx={inputSx} placeholder="Enter test pressure" />
//                   </Box>
//                 </Grid>

//                 {/* Working Pressure */}
//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Working Pressure</Typography>
//                     <TextField size="small" fullWidth type="text" onChange={handleChange}
//                       name="working_pressure" value={data.working_pressure} sx={inputSx} placeholder="Enter working pressure" />
//                   </Box>
//                 </Grid>

//                 {/* Cylinder Manufacturer */}
//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Cylinder Manufacturer</Typography>
//                     <TextField size="small" fullWidth type="text" onChange={handleChange}
//                       name="cylinder_manufacturer" value={data.cylinder_manufacturer} sx={inputSx} placeholder="Enter manufacturer" />
//                   </Box>
//                 </Grid>

//                 {/* Cylinder Manufacturing Code */}
//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Cylinder Manufacturing Code <span style={{ color: "#E53E3E" }}>*</span></Typography>
//                     <TextField size="small" fullWidth type="text" onChange={handleChange}
//                       name="cylinder_manufacturing_code" value={data.cylinder_manufacturing_code} sx={inputSx} placeholder="Enter manufacturing code" />
//                   </Box>
//                 </Grid>

//                 {/* Cylinder Manufacturing Date */}
//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Cylinder Manufacturing Date</Typography>
//                     <DatePicker format="DD/MM/YYYY"
//                       value={data.cylinder_manufacturing_date ? dayjs(data.cylinder_manufacturing_date) : dayjs()}
//                       onChange={(v) => handleChange({ target: { name: "cylinder_manufacturing_date", value: v ? v.format("YYYY-MM-DD") : "" } })}
//                       slotProps={{ textField: { size: "small", fullWidth: true, sx: inputSx } }} />
//                   </Box>
//                 </Grid>

//                 {/* Cylinder Purchase Date */}
//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Cylinder Purchase Date</Typography>
//                     <DatePicker format="DD/MM/YYYY"
//                       value={data.cylinder_purchase_date ? dayjs(data.cylinder_purchase_date) : null}
//                       onChange={(v) => handleChange({ target: { name: "cylinder_purchase_date", value: v ? v.format("YYYY-MM-DD") : "" } })}
//                       slotProps={{ textField: { size: "small", fullWidth: true, sx: inputSx } }} />
//                   </Box>
//                 </Grid>

//                 {/* Valve Type */}
//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Valve Type</Typography>
//                     <TextField size="small" fullWidth type="text" onChange={handleChange}
//                       name="valve_type" value={data.valve_type} sx={inputSx} placeholder="Enter valve type" />
//                   </Box>
//                 </Grid>

//                 {/* Valve Manufacturer */}
//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Valve Manufacturer</Typography>
//                     <TextField size="small" fullWidth type="text" onChange={handleChange}
//                       name="valve_manufacturer" value={data.valve_manufacturer} sx={inputSx} placeholder="Enter valve manufacturer" />
//                   </Box>
//                 </Grid>

//                 {/* Valve Manufacturing Code */}
//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Valve Manufacturing Code</Typography>
//                     <TextField size="small" fullWidth type="text" onChange={handleChange}
//                       name="valve_manufacturing_code" value={data.valve_manufacturing_code} sx={inputSx} placeholder="Enter valve manufacturing code" />
//                   </Box>
//                 </Grid>

//                 {/* Valve Test Pressure */}
//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Valve Test Pressure</Typography>
//                     <TextField size="small" fullWidth type="text" onChange={handleChange}
//                       name="valve_test_pressure" value={data.valve_test_pressure} sx={inputSx} placeholder="Enter valve test pressure" />
//                   </Box>
//                 </Grid>

//                 {/* Valve Working Pressure */}
//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Valve Working Pressure</Typography>
//                     <TextField size="small" fullWidth type="text" onChange={handleChange}
//                       name="valve_working_pressure" value={data.valve_working_pressure} sx={inputSx} placeholder="Enter valve working pressure" />
//                   </Box>
//                 </Grid>

//                 {/* PESO Approval No */}
//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Peso Approval No</Typography>
//                     <TextField size="small" fullWidth type="text" onChange={handleChange}
//                       name="peso_approval_no" value={data.peso_approval_no} sx={inputSx} placeholder="Enter PESO approval number" />
//                   </Box>
//                 </Grid>

//                 {/* PESO Approval Date */}
//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Peso Approval Date</Typography>
//                     <DatePicker format="DD/MM/YYYY"
//                       value={data.peso_approval_date ? dayjs(data.peso_approval_date) : dayjs()}
//                       onChange={(v) => handleChange({ target: { name: "peso_approval_date", value: v ? v.format("YYYY-MM-DD") : "" } })}
//                       slotProps={{ textField: { size: "small", fullWidth: true, sx: inputSx } }} />
//                   </Box>
//                 </Grid>

//                 {/* PESO Certificate Upload */}
//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Peso Certificate Upload</Typography>
//                     <TextField size="small" fullWidth type="file" onChange={uploadFile}
//                       name="peso_certificate_upload" sx={inputSx}
//                       InputProps={{ inputProps: { accept: ".pdf,.jpg,.png" } }} />
//                     {pesoCertificateFile && (
//                       <Typography sx={{ fontSize: "11px", color: "#718096", mt: 0.5 }}>{pesoCertificateFile.name}</Typography>
//                     )}
//                   </Box>
//                 </Grid>

//                 {/* Hydrotest Certificate No */}
//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Hydrotest Certificate No</Typography>
//                     <TextField size="small" fullWidth type="text" onChange={handleChange}
//                       name="hydrotest_certificate_no" value={data.hydrotest_certificate_no} sx={inputSx} placeholder="Enter hydrotest certificate number" />
//                   </Box>
//                 </Grid>

//                 {/* Hydrotest Date */}
//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Hydrotest Date</Typography>
//                     <DatePicker format="DD/MM/YYYY"
//                       value={data.hydrotest_date ? dayjs(data.hydrotest_date) : dayjs()}
//                       onChange={(v) => handleChange({ target: { name: "hydrotest_date", value: v ? v.format("YYYY-MM-DD") : "" } })}
//                       slotProps={{ textField: { size: "small", fullWidth: true, sx: inputSx } }} />
//                   </Box>
//                 </Grid>

//                 {/* Hydrotest Certificate Upload */}
//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Hydrotest Certificate Upload</Typography>
//                     <TextField size="small" fullWidth type="file" onChange={uploadHydrotestFile}
//                       name="hydrotest_certificate_upload" sx={inputSx}
//                       InputProps={{ inputProps: { accept: ".pdf,.jpg,.png" } }} />
//                     {hydrotestCertificateFile && (
//                       <Typography sx={{ fontSize: "11px", color: "#718096", mt: 0.5 }}>{hydrotestCertificateFile.name}</Typography>
//                     )}
//                   </Box>
//                 </Grid>

//                 {/* Current Location */}
//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Current Location</Typography>
//                     <TextField select size="small" fullWidth onChange={handleChange}
//                       name="current_location" value={data.current_location} sx={inputSx}>
//                       <MenuItem value=""><em>None</em></MenuItem>
//                       <MenuItem value="Customer" sx={{ fontSize: "13px" }}>Customer</MenuItem>
//                       <MenuItem value="Plant" sx={{ fontSize: "13px" }}>Plant</MenuItem>
//                       <MenuItem value="Depot" sx={{ fontSize: "13px" }}>Depot</MenuItem>
//                       <MenuItem value="Vehicle" sx={{ fontSize: "13px" }}>Vehicle</MenuItem>
//                     </TextField>
//                   </Box>
//                 </Grid>

//                 {/* Conditional: Depot */}
//                 {data.current_location === "Depot" && (
//                   <Grid item xs={12} md={6}>
//                     <AutocompleteField
//                       label="Depot"
//                       options={depot}
//                       getOptionLabel={(o) => o?.depot_name || ""}
//                       value={depot?.find((i) => String(i.depot_id) === String(data.current_depot_id)) || null}
//                       onChange={(e, v) => handleChange({ target: { name: "current_depot_id", value: v ? v.depot_id : "" } })}
//                       isOptionEqualToValue={(o, v) => String(o.depot_id) === String(v.depot_id)}
//                     />
//                   </Grid>
//                 )}

//                 {/* Conditional: Plant */}
//                 {data.current_location === "Plant" && (
//                   <Grid item xs={12} md={6}>
//                     <AutocompleteField
//                       label="Plant"
//                       options={plant}
//                       getOptionLabel={(o) => o?.plant_name || ""}
//                       value={plant?.find((i) => String(i.plant_id) === String(data.current_plant_id)) || null}
//                       onChange={(e, v) => handleChange({ target: { name: "current_plant_id", value: v ? v.plant_id : "" } })}
//                       isOptionEqualToValue={(o, v) => String(o.plant_id) === String(v.plant_id)}
//                     />
//                   </Grid>
//                 )}

//                 {/* Conditional: Customer */}
//                 {data.current_location === "Customer" && (
//                   <Grid item xs={12} md={6}>
//                     <AutocompleteField
//                       label="Customer"
//                       options={customer}
//                       getOptionLabel={(o) => o?.cust_name || ""}
//                       value={customer?.find((i) => String(i.cust_id) === String(data.current_customer_id)) || null}
//                       onChange={(e, v) => handleChange({ target: { name: "current_customer_id", value: v ? v.cust_id : "" } })}
//                       isOptionEqualToValue={(o, v) => String(o.cust_id) === String(v.cust_id)}
//                     />
//                   </Grid>
//                 )}

//                 {/* Conditional: Vehicle */}
//                 {data.current_location === "Vehicle" && (
//                   <Grid item xs={12} md={6}>
//                     <AutocompleteField
//                       label="Vehicle"
//                       options={vehicle}
//                       getOptionLabel={(o) => o?.vehicle_no || ""}
//                       value={vehicle?.find((i) => String(i.vehicle_id) === String(data.current_vehicle_id)) || null}
//                       onChange={(e, v) => handleChange({ target: { name: "current_vehicle_id", value: v ? v.vehicle_id : "" } })}
//                       isOptionEqualToValue={(o, v) => String(o.vehicle_id) === String(v.vehicle_id)}
//                     />
//                   </Grid>
//                 )}

//                 {/* Storage */}
//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Storage</Typography>
//                     <TextField select size="small" fullWidth onChange={handleChange}
//                       name="storage" value={data.storage} sx={inputSx}>
//                       <MenuItem value=""></MenuItem>
//                       <MenuItem value="Empty Store" sx={{ fontSize: "13px" }}>Empty Store</MenuItem>
//                       <MenuItem value="Fog Store" sx={{ fontSize: "13px" }}>FG Store</MenuItem>
//                       <MenuItem value="Production Bay" sx={{ fontSize: "13px" }}>Production Bay</MenuItem>
//                       <MenuItem value="Inspection Bay" sx={{ fontSize: "13px" }}>Inspection Bay</MenuItem>
//                       <MenuItem value="Maintenance Yard" sx={{ fontSize: "13px" }}>Maintenance Yard</MenuItem>
//                     </TextField>
//                   </Box>
//                 </Grid>

//                 {/* Status */}
//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Status</Typography>
//                     <TextField select size="small" fullWidth onChange={handleChange}
//                       name="status" value={data.status} sx={inputSx}>
//                       <MenuItem value=""></MenuItem>
//                       <MenuItem value="Empty" sx={{ fontSize: "13px" }}>Empty</MenuItem>
//                       <MenuItem value="Full" sx={{ fontSize: "13px" }}>Full</MenuItem>
//                     </TextField>
//                   </Box>
//                 </Grid>

//                 {/* Note */}
//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Note</Typography>
//                     <TextField select size="small" fullWidth onChange={handleChange}
//                       name="note" value={data.note} sx={inputSx}>
//                       <MenuItem value=""></MenuItem>
//                       <MenuItem value="OK" sx={{ fontSize: "13px" }}>OK</MenuItem>
//                       <MenuItem value="Not OK" sx={{ fontSize: "13px" }}>Not OK</MenuItem>
//                     </TextField>
//                   </Box>
//                 </Grid>

//               </Grid>
//             </Box>

//             {/* Form Footer */}
//             <Box sx={formFooterSx}>
//               <Button sx={cancelBtnSx} onClick={handleBack}>Cancel</Button>
//               <Button type="submit" sx={saveBtnSx}>
//                 <SaveIcon sx={{ fontSize: 18 }} />
//                 {editData ? "Update" : "Save"}
//               </Button>
//             </Box>

//           </Box>
//         </form>

//         <ReusableSnackbar
//           open={!!successMessage}
//           onClose={(event, reason) => { if (reason !== 'clickaway') setSuccessMessage(""); }}
//           message={successMessage}
//           autoHideDuration={2000}
//           vertical="top"
//           horizontal="right"
//         />
//       </Box>
//     </LocalizationProvider>
//   );
// };

// export default CylinderAdd;

// import {
//   Autocomplete,
//   Box,
//   Button,
//   IconButton,
//   MenuItem,
//   TextField,
//   Typography,
// } from "@mui/material";
// import { useEffect, useState } from "react";
// import Grid from "@mui/material/Grid";
// import AddIcon from '@mui/icons-material/Add';
// import { useForm } from "react-hook-form";
// import { useLocation, useNavigate } from "react-router-dom";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import SaveIcon from "@mui/icons-material/Save";
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import PropaneTankIcon from '@mui/icons-material/PropaneTank';
// import { useDispatch } from "react-redux";
// import dayjs from "dayjs";
// import customerMasterService from "../../../services/masters/customerMaster.Service";
// import depotMasterService from "../../../services/masters/depotMaster.Service";
// import productMasterService from "../../../services/masters/productMaster.Service";
// import uomMasterService from "../../../services/masters/uomMaster.Service";
// import cylinderMasterService from "../../../services/masters/cylinderMaster.Service";
// import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
// import plantmasterservices from "../../../services/masters/plantMaster.Service";
// import vehiclemasterservices from "../../../services/masters/vehicleMaster.Service";

// // ── CSS Styles (same as PlantAdd) ──────────────────────────────────────────

// const pageSx = {
//   background: "#F4F7FB",
//   minHeight: "100vh",
//   padding: "20px 24px 40px",
//   fontFamily: "'Inter', Arial, sans-serif",
// };

// const breadcrumbSx = {
//   fontSize: "12px",
//   color: "#718096",
//   mb: 2,
//   display: "flex",
//   alignItems: "center",
//   gap: "6px",
// };

// const pageHeaderSx = {
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "space-between",
//   mb: 2.5,
// };

// const pageTitleSx = {
//   fontSize: "16px",
//   fontWeight: 700,
//   color: "#000000",
//   display: "flex",
//   alignItems: "center",
//   gap: "10px",
// };

// const backBtnSx = {
//   display: "flex",
//   alignItems: "center",
//   gap: "6px",
//   fontSize: "13px",
//   fontWeight: 600,
//   color: "#2B6CB0",
//   padding: "7px 14px",
//   border: "1.5px solid #2B6CB0",
//   borderRadius: "7px",
//   background: "#fff",
//   cursor: "pointer",
//   textTransform: "none",
//   "&:hover": { background: "#E6F1FB" },
// };

// const formCardSx = {
//   background: "#fff",
//   borderRadius: "14px",
//   border: "1px solid #E2E8F0",
//   overflow: "hidden",
//   mb: 3,
// };

// const sectionHeaderSx = {
//   background: "#1C3A5E",
//   padding: "12px 22px",
//   display: "flex",
//   alignItems: "center",
//   gap: "10px",
// };

// const sectionHeaderTitleSx = {
//   fontSize: "13px",
//   fontWeight: 600,
//   color: "#fff",
//   letterSpacing: "0.3px",
// };

// const formBodySx = { padding: "22px 24px" };

// const fieldLabelSx = {
//   fontSize: "12px",
//   fontWeight: 600,
//   color: "#2063b6",
//   mb: "4px",
//   display: "flex",
//   alignItems: "center",
//   gap: "4px",
// };

// const inputSx = {
//   "& .MuiOutlinedInput-root": {
//     borderRadius: "8px",
//     fontSize: "13px",
//     fontFamily: "'Inter', Arial, sans-serif",
//     background: "#fafafa",
//     height: "38px",
//     "& fieldset": { borderColor: "#E2E8F0", borderWidth: "1.5px" },
//     "&:hover fieldset": { borderColor: "#CBD5E0" },
//     "&.Mui-focused fieldset": { borderColor: "#2B6CB0", borderWidth: "2px" },
//     "&.Mui-focused": { background: "#fff" },
//     "&.Mui-disabled": { background: "#F8FAFC" },
//   },
//   "& input": {
//     color: "#1A202C",
//     fontSize: "13px",
//     fontFamily: "'Inter', Arial, sans-serif",
//     "&::placeholder": { color: "#A0AEC0", opacity: 1 },
//   },
//   "& .MuiInputLabel-root": { display: "none" },
// };

// const readOnlyInputSx = {
//   ...inputSx,
//   "& .MuiOutlinedInput-root": {
//     ...inputSx["& .MuiOutlinedInput-root"],
//     background: "#f0f4f8",
//   },
// };

// const subSectionHeaderSx = {
//   background: "#1C3A5E",
//   padding: "12px 22px",
//   display: "flex",
//   alignItems: "center",
//   gap: "10px",
//   borderTop: "1px solid #E2E8F0",
// };

// const formFooterSx = {
//   padding: "18px 24px",
//   background: "#F8FAFC",
//   borderTop: "1px solid #E2E8F0",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "flex-end",
//   gap: "10px",
// };

// const saveBtnSx = {
//   display: "flex",
//   alignItems: "center",
//   gap: "7px",
//   padding: "0 22px",
//   height: "40px",
//   background: "#4CAF50",
//   color: "#fff",
//   border: "none",
//   fontSize: "14px",
//   fontWeight: 600,
//   textTransform: "none",
//   fontFamily: "'Inter', Arial, sans-serif",
//   "&:hover": { background: "#028b19", transform: "translateY(-1px)" },
//   "&:active": { transform: "translateY(0)" },
//   "&.Mui-disabled": { background: "#94a3b8", color: "#fff" },
//   transition: "all 0.15s ease",
// };

// const cancelBtnSx = {
//   display: "flex",
//   alignItems: "center",
//   gap: "7px",
//   padding: "0 22px",
//   height: "40px",
//   background: "#E53E3E",
//   color: "#ffffff",
//   border: "none",
//   "&:hover": { background: "#971f16", transform: "translateY(-1px)" },
//   fontSize: "14px",
//   fontWeight: 600,
//   borderRadius: "8px",
// };

// const addIconBtnSx = {
//   color: "#2B6CB0",
//   border: "1px solid #2B6CB0",
//   borderRadius: "6px",
//   p: "5px",
//   ml: 0.5,
//   flexShrink: 0,
// };

// // ─────────────────────────────────────────────────────────────────────────────

// const CylinderAdd = () => {
//   const { handleSubmit } = useForm({ mode: 'onSubmit' });
//   const dispatch = useDispatch();
//   const login_details = sessionStorage.getItem('loginUser');
//   const userD = JSON.parse(login_details);
//   const userInfo = userD.result.userInfo;
//   const urlLocation = useLocation();
//   const editInfo = urlLocation.state;
//   const editData = editInfo && editInfo;

//   const getFileNameFromUrl = (url) => {
//     try {
//       const path = new URL(url).pathname;
//       return path.substring(path.lastIndexOf("/") + 1);
//     } catch (error) {
//       return "";
//     }
//   };

//   const [pesoCertificateFile, setPesoCertificateFile] = useState(
//     editData && editData.peso_certificate_upload
//       ? { name: getFileNameFromUrl(editData.peso_certificate_upload) } : null
//   );
//   const [hydrotestCertificateFile, setHydrotestCertificateFile] = useState(
//     editData && editData.hydrotest_certificate_upload
//       ? { name: getFileNameFromUrl(editData.hydrotest_certificate_upload) } : null
//   );

//   const [data, setData] = useState({
//     cylinder_no: editData ? editData.cylinder_no : "",
//     owner: editData ? editData.owner : "",
//     prod_id: editData ? editData.prod_id : null,
//     plant_id: editData ? editData.plant_id : "",
//     depot_id: editData ? editData.depot_id : "",
//     prod_code: editData ? editData.prod_code : "",
//     prod_description: editData ? editData.prod_description : "",
//     cyl_capacity: editData ? editData.cyl_capacity : "",
//     uom: editData ? editData.uom : "",
//     purchase_date: editData?.purchase_date && !isNaN(new Date(editData.purchase_date))
//       ? new Date(editData.purchase_date).toISOString().split("T")[0]
//       : new Date().toISOString().split("T")[0],
//     tare_wt: editData ? editData.tare_wt : "",
//     water_capacity: editData ? editData.water_capacity : "",
//     test_pressure: editData ? editData.test_pressure : "",
//     working_pressure: editData ? editData.working_pressure : "",
//     cylinder_manufacturer: editData ? editData.cylinder_manufacturer : "",
//     tag_no: editData ? editData.tag_no : "",
//     cylinder_manufacturing_code: editData ? editData.cylinder_manufacturing_code : "",
//     cylinder_manufacturing_date: editData?.cylinder_manufacturing_date && !isNaN(new Date(editData.cylinder_manufacturing_date))
//       ? new Date(editData.cylinder_manufacturing_date).toISOString().split("T")[0]
//       : new Date().toISOString().split("T")[0],
//     cylinder_purchase_date: editData?.cylinder_purchase_date && !isNaN(new Date(editData.cylinder_purchase_date))
//       ? new Date(editData.cylinder_purchase_date).toISOString().split("T")[0]
//       : new Date().toISOString().split("T")[0],
//     valve_type: editData ? editData.valve_type : "",
//     valve_manufacturer: editData ? editData.valve_manufacturer : "",
//     valve_manufacturing_code: editData ? editData.valve_manufacturing_code : "",
//     valve_test_pressure: editData ? editData.valve_test_pressure : "",
//     valve_working_pressure: editData ? editData.valve_working_pressure : "",
//     peso_approval_no: editData ? editData.peso_approval_no : "",
//     peso_approval_date: editData?.peso_approval_date && !isNaN(new Date(editData.peso_approval_date))
//       ? new Date(editData.peso_approval_date).toISOString().split("T")[0]
//       : new Date().toISOString().split("T")[0],
//     peso_certificate_upload: editData ? editData.peso_certificate_upload : "",
//     hydrotest_certificate_no: editData ? editData.hydrotest_certificate_no : "",
//     hydrotest_date: editData?.hydrotest_date && !isNaN(new Date(editData.hydrotest_date))
//       ? new Date(editData.hydrotest_date).toISOString().split("T")[0]
//       : new Date().toISOString().split("T")[0],
//     hydrotest_certificate_upload: editData ? editData.hydrotest_certificate_upload : "",
//     current_location: editData ? editData.current_location : "",
//     current_plant_id: editData ? editData.current_plant_id : "",
//     current_vehicle_id: editData ? editData.current_vehicle_id : "",
//     current_depot_id: editData ? editData.current_depot_id : "",
//     cust_id: editData ? editData.customer_id : "",
//     current_customer_id: editData ? editData.current_customer_id : "",
//     status: editData ? editData.status : "",
//     note: editData ? editData.note : "",
//     storage: editData ? editData.storage : "",
//   });

//   const [successMessage, setSuccessMessage] = useState(null);
//   const [customer, setCustomer] = useState([]);
//   const [depot, setDepot] = useState([]);
//   const [product, setProduct] = useState([]);
//   const [uom, setUOM] = useState([]);
//   const [plant, setPlant] = useState([]);
//   const [vehicle, setvehicle] = useState([]);

//   useEffect(() => {
//     async function fetchData() {
//       try {
//         const [customerData, depotData, productData, uomData, plantdata, vehicleData] = await Promise.all([
//           customerMasterService.getCustomerList({ page: 0, size: 999, searchKey: "" }),
//           depotMasterService.getDepotList({ page: 0, size: 999, searchKey: "" }),
//           productMasterService.getProductList({ page: 0, size: 999, searchKey: "" }),
//           uomMasterService.getUOMList({ page: 0, size: 999, searchKey: "" }),
//           plantmasterservices.getPlantList({ page: 0, size: 999, searchKey: "" }),
//           vehiclemasterservices.getVehicleList({ page: 0, size: 999, searchKey: "" }),
//         ]);
//         setCustomer(customerData);
//         setDepot(depotData);
//         setProduct(productData);
//         setUOM(uomData);
//         setPlant(plantdata);
//         setvehicle(vehicleData);
//       } catch (error) {
//         console.error("Data fetching failed", error);
//       }
//     }
//     fetchData();
//   }, []);

//   useEffect(() => {
//     let objectUrlPo, objectUrlQuotation;
//     if (pesoCertificateFile instanceof File) objectUrlPo = URL.createObjectURL(pesoCertificateFile);
//     if (hydrotestCertificateFile instanceof File) objectUrlQuotation = URL.createObjectURL(hydrotestCertificateFile);
//     return () => {
//       if (objectUrlPo) URL.revokeObjectURL(objectUrlPo);
//       if (objectUrlQuotation) URL.revokeObjectURL(objectUrlQuotation);
//     };
//   }, [pesoCertificateFile, hydrotestCertificateFile]);

//   const handleChange = ({ target }) => {
//     const { name, value } = target;
//     if (name === "prod_code") {
//       const selectedProduct = product.find((p) => p.prod_code === value);
//       setData({ ...data, prod_code: value, prod_id: selectedProduct?.prod_id || "", prod_description: selectedProduct?.prod_description || "" });
//     } else {
//       setData({ ...data, [name]: value });
//     }
//   };

//   const uploadFile = (e) => {
//     const file = e.target.files[0];
//     setPesoCertificateFile(file);
//     setData((prev) => ({ ...prev, peso_certificate_upload: file ? file.name : "" }));
//   };

//   const uploadHydrotestFile = (e) => {
//     const file = e.target.files[0];
//     setHydrotestCertificateFile(file);
//     setData((prev) => ({ ...prev, hydrotest_certificate_upload: file ? file.name : "" }));
//   };

//   const navigate = useNavigate();
//   const handleBack = () => navigate(-1);
//   const handleNavigate = (path) => navigate(path);

//   const onSubmit = async () => {
//     const cylinderData = {
//       cylinder_no: data.cylinder_no, owner: data.owner, prod_id: data.prod_id,
//       plant_id: data.plant_id, prod_code: data.prod_code, prod_description: data.prod_description,
//       cyl_capacity: data.cyl_capacity, uom: data.uom, purchase_date: data.purchase_date,
//       tare_wt: data.tare_wt, water_capacity: data.water_capacity, test_pressure: data.test_pressure,
//       working_pressure: data.working_pressure, cylinder_manufacturer: data.cylinder_manufacturer,
//       tag_no: data.tag_no, cylinder_manufacturing_code: data.cylinder_manufacturing_code,
//       cylinder_manufacturing_date: data.cylinder_manufacturing_date,
//       cylinder_purchase_date: data.cylinder_purchase_date, valve_type: data.valve_type,
//       valve_manufacturer: data.valve_manufacturer, valve_manufacturing_code: data.valve_manufacturing_code,
//       valve_test_pressure: data.valve_test_pressure, valve_working_pressure: data.valve_working_pressure,
//       peso_approval_no: data.peso_approval_no, peso_approval_date: data.peso_approval_date,
//       hydrotest_certificate_no: data.hydrotest_certificate_no, hydrotest_date: data.hydrotest_date,
//       current_location: data.current_location, current_plant_id: data.current_plant_id,
//       current_vehicle_id: data.current_vehicle_id, current_depot_id: data.current_depot_id,
//       current_customer_id: data.current_customer_id, customer_id: data.cust_id,
//       status: data.status, note: data.note, storage: data.storage,
//       modified_at: dayjs().format('YYYY-MM-DD HH:mm:ss'),
//       modified_by: editData ? userInfo.user_id : null,
//       created_at: dayjs().format('YYYY-MM-DD HH:mm:ss'),
//       created_by: editData ? editData.created_by : userInfo.user_id,
//       changedUpdatedValue: "edit",
//       cyl_id: editData ? editData.cyl_id : "",
//     };
//     const formData = new FormData();
//     formData.append("cylinderData", JSON.stringify(cylinderData));
//     if (pesoCertificateFile instanceof File) formData.append("peso_certificate_upload", pesoCertificateFile);
//     else if (editData?.peso_certificate_upload) formData.append("peso_certificate_upload", editData.peso_certificate_upload);
//     if (hydrotestCertificateFile instanceof File) formData.append("hydrotest_certificate_upload", hydrotestCertificateFile);
//     else if (editData?.hydrotest_certificate_upload) formData.append("hydrotest_certificate_upload", editData.hydrotest_certificate_upload);
//     try {
//       if (editData) {
//         await cylinderMasterService.editDeleteCylinder(formData);
//         setSuccessMessage("Updated successfully");
//       } else {
//         await cylinderMasterService.addCylinder(formData);
//         setSuccessMessage("Added successfully");
//       }
//       setTimeout(() => { navigate(-1); setSuccessMessage(null); }, 1000);
//     } catch (error) {
//       setSuccessMessage(`Error: ${error.message || "An error occurred"}`);
//     }
//   };

//   // Helper for Autocomplete field
//   const AutocompleteField = ({ label, required, options, getOptionLabel, value, onChange, isOptionEqualToValue, onAddClick, renderOption }) => (
//     <Box>
//       <Typography sx={fieldLabelSx}>
//         {label} {required && <span style={{ color: "#E53E3E" }}>*</span>}
//       </Typography>
//       <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
//         <Autocomplete
//           options={options || []}
//           fullWidth
//           getOptionLabel={getOptionLabel}
//           value={value}
//           onChange={onChange}
//           renderOption={renderOption || ((props, option) => (
//             <MenuItem {...props} sx={{ fontSize: "13px" }}>{getOptionLabel(option)}</MenuItem>
//           ))}
//           renderInput={(params) => (
//             <TextField {...params} size="small" fullWidth sx={inputSx} required={required} />
//           )}
//           isOptionEqualToValue={isOptionEqualToValue}
//         />
//         {onAddClick && (
//           <IconButton size="small" onClick={onAddClick} sx={addIconBtnSx}>
//             <AddIcon fontSize="small" />
//           </IconButton>
//         )}
//       </Box>
//     </Box>
//   );

//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <Box sx={pageSx}>

//         {/* Breadcrumb */}
//         <Box sx={breadcrumbSx}>
//           <span>Dashboard</span> / <span style={{ color: "#2B6CB0", fontWeight: 600 }}>Cylinder</span>
//         </Box>

//         {/* Page Header */}
//         <Box sx={pageHeaderSx}>
//           <Box sx={pageTitleSx}>
//             <PropaneTankIcon sx={{ fontSize: 20, color: "#1C3A5E" }} />
//             {editData ? "UPDATE" : "ADD"} CYLINDER
//           </Box>
//           <Button onClick={handleBack} sx={backBtnSx}>
//             <ArrowBackIcon sx={{ fontSize: 16 }} /> Back
//           </Button>
//         </Box>

//         <form onSubmit={handleSubmit(onSubmit)}>

//           {/* ── Section 1: Basic Info ── */}
//           <Box sx={formCardSx}>
//             <Box sx={sectionHeaderSx}>
//               <PropaneTankIcon sx={{ fontSize: 18, color: "#fff" }} />
//               <Typography sx={sectionHeaderTitleSx}>Basic Information</Typography>
//             </Box>
//             <Box sx={formBodySx}>
//               <Grid container spacing={3}>

//                 {/* Cylinder No */}
//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Cylinder No <span style={{ color: "#E53E3E" }}>*</span></Typography>
//                     <TextField size="small" fullWidth type="text" onChange={handleChange}
//                       name="cylinder_no" value={data.cylinder_no} required sx={inputSx} placeholder="Enter cylinder number" />
//                   </Box>
//                 </Grid>

//                 {/* Cylinder Tag */}
//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Cylinder Tag</Typography>
//                     <TextField size="small" fullWidth type="text" onChange={handleChange}
//                       name="tag_no" value={data.tag_no} sx={inputSx} placeholder="Enter tag number" />
//                   </Box>
//                 </Grid>

//                 {/* Owner */}
//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Owner <span style={{ color: "#E53E3E" }}>*</span></Typography>
//                     <TextField select size="small" fullWidth required onChange={handleChange}
//                       name="owner" value={data.owner} sx={inputSx}>
//                       <MenuItem value="TGPL" sx={{ fontSize: "13px" }}>TGPL</MenuItem>
//                       <MenuItem value="Customer" sx={{ fontSize: "13px" }}>Customer</MenuItem>
//                     </TextField>
//                   </Box>
//                 </Grid>

//                 {/* Customer Name (conditional) */}
//                 {data.owner === "Customer" && (
//                   <Grid item xs={12} md={6}>
//                     <Box>
//                       <Typography sx={fieldLabelSx}>Customer Name</Typography>
//                       <TextField select size="small" fullWidth onChange={handleChange}
//                         name="cust_id" value={data.cust_id || ""} sx={inputSx}>
//                         <MenuItem value=""><em>Select Customer</em></MenuItem>
//                         {customer.map((c) => (
//                           <MenuItem key={c.cust_id} value={c.cust_id} sx={{ fontSize: "13px" }}>{c.cust_name}</MenuItem>
//                         ))}
//                       </TextField>
//                     </Box>
//                   </Grid>
//                 )}

//                 {/* Plant */}
//                 <Grid item xs={12} md={6}>
//                   <AutocompleteField
//                     label="Plant"
//                     options={plant}
//                     getOptionLabel={(o) => o?.plant_name || ""}
//                     value={plant?.find((i) => String(i.plant_id) === String(data.plant_id)) || null}
//                     onChange={(e, v) => handleChange({ target: { name: "plant_id", value: v ? v.plant_id : "" } })}
//                     isOptionEqualToValue={(o, v) => String(o.plant_id) === String(v.plant_id)}
//                     onAddClick={() => handleNavigate('/masters/Addplant')}
//                   />
//                 </Grid>

//                 {/* Product Code */}
//                 <Grid item xs={12} md={6}>
//                   <AutocompleteField
//                     label="Product Code" required
//                     options={product}
//                     getOptionLabel={(o) => o?.prod_code || ""}
//                     value={product?.find((p) => p.prod_code === data.prod_code) || null}
//                     onChange={(e, v) => handleChange({ target: { name: "prod_code", value: v ? v.prod_code : "" } })}
//                     isOptionEqualToValue={(o, v) => o.prod_code === v.prod_code}
//                   />
//                 </Grid>

//                 {/* Product Description (readonly) */}
//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Product Description</Typography>
//                     <TextField size="small" fullWidth value={data.prod_description}
//                       sx={readOnlyInputSx} InputProps={{ readOnly: true }} placeholder="Auto-filled from product code" />
//                   </Box>
//                 </Grid>

//                 {/* UOM */}
//                 <Grid item xs={12} md={6}>
//                   <AutocompleteField
//                     label="UOM"
//                     options={uom}
//                     getOptionLabel={(o) => o?.uom || ""}
//                     value={uom?.find((u) => u.uom === data.uom) || null}
//                     onChange={(e, v) => handleChange({ target: { name: "uom", value: v ? v.uom : "" } })}
//                     isOptionEqualToValue={(o, v) => o.uom === v.uom}
//                     onAddClick={() => handleNavigate('/masters/add-uom')}
//                   />
//                 </Grid>

//                 {/* Cylinder Capacity */}
//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Cylinder Capacity (Kg)</Typography>
//                     <TextField size="small" fullWidth type="text" onChange={handleChange}
//                       name="cyl_capacity" value={data.cyl_capacity} sx={inputSx} placeholder="Enter capacity" />
//                   </Box>
//                 </Grid>

//                 {/* Tare Wt */}
//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Tare Wt</Typography>
//                     <TextField size="small" fullWidth type="text" onChange={handleChange}
//                       name="tare_wt" value={data.tare_wt} sx={inputSx} placeholder="Enter tare weight" />
//                   </Box>
//                 </Grid>

//                 {/* Water Capacity */}
//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Water Capacity</Typography>
//                     <TextField size="small" fullWidth type="text" onChange={handleChange}
//                       name="water_capacity" value={data.water_capacity} sx={inputSx} placeholder="Enter water capacity" />
//                   </Box>
//                 </Grid>

//               </Grid>
//             </Box>

//             {/* ── Section 2: Specifications ── */}
//             <Box sx={subSectionHeaderSx}>
//               <PropaneTankIcon sx={{ fontSize: 18, color: "#fff" }} />
//               <Typography sx={sectionHeaderTitleSx}>Specifications</Typography>
//             </Box>
//             <Box sx={formBodySx}>
//               <Grid container spacing={3}>

//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Test Pressure</Typography>
//                     <TextField size="small" fullWidth type="text" onChange={handleChange}
//                       name="test_pressure" value={data.test_pressure} sx={inputSx} placeholder="Enter test pressure" />
//                   </Box>
//                 </Grid>

//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Working Pressure</Typography>
//                     <TextField size="small" fullWidth type="text" onChange={handleChange}
//                       name="working_pressure" value={data.working_pressure} sx={inputSx} placeholder="Enter working pressure" />
//                   </Box>
//                 </Grid>

//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Cylinder Manufacturer</Typography>
//                     <TextField size="small" fullWidth type="text" onChange={handleChange}
//                       name="cylinder_manufacturer" value={data.cylinder_manufacturer} sx={inputSx} placeholder="Enter manufacturer" />
//                   </Box>
//                 </Grid>

//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Cylinder Manufacturing Code <span style={{ color: "#E53E3E" }}>*</span></Typography>
//                     <TextField size="small" fullWidth type="text" onChange={handleChange}
//                       name="cylinder_manufacturing_code" value={data.cylinder_manufacturing_code} sx={inputSx} placeholder="Enter manufacturing code" />
//                   </Box>
//                 </Grid>

//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Cylinder Manufacturing Date</Typography>
//                     <DatePicker format="DD/MM/YYYY"
//                       value={data.cylinder_manufacturing_date ? dayjs(data.cylinder_manufacturing_date) : dayjs()}
//                       onChange={(v) => handleChange({ target: { name: "cylinder_manufacturing_date", value: v ? v.format("YYYY-MM-DD") : "" } })}
//                       slotProps={{ textField: { size: "small", fullWidth: true, sx: inputSx } }} />
//                   </Box>
//                 </Grid>

//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Cylinder Purchase Date</Typography>
//                     <DatePicker format="DD/MM/YYYY"
//                       value={data.cylinder_purchase_date ? dayjs(data.cylinder_purchase_date) : null}
//                       onChange={(v) => handleChange({ target: { name: "cylinder_purchase_date", value: v ? v.format("YYYY-MM-DD") : "" } })}
//                       slotProps={{ textField: { size: "small", fullWidth: true, sx: inputSx } }} />
//                   </Box>
//                 </Grid>

//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Valve Type</Typography>
//                     <TextField size="small" fullWidth type="text" onChange={handleChange}
//                       name="valve_type" value={data.valve_type} sx={inputSx} placeholder="Enter valve type" />
//                   </Box>
//                 </Grid>

//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Valve Manufacturer</Typography>
//                     <TextField size="small" fullWidth type="text" onChange={handleChange}
//                       name="valve_manufacturer" value={data.valve_manufacturer} sx={inputSx} placeholder="Enter valve manufacturer" />
//                   </Box>
//                 </Grid>

//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Valve Manufacturing Code</Typography>
//                     <TextField size="small" fullWidth type="text" onChange={handleChange}
//                       name="valve_manufacturing_code" value={data.valve_manufacturing_code} sx={inputSx} placeholder="Enter valve manufacturing code" />
//                   </Box>
//                 </Grid>

//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Valve Test Pressure</Typography>
//                     <TextField size="small" fullWidth type="text" onChange={handleChange}
//                       name="valve_test_pressure" value={data.valve_test_pressure} sx={inputSx} placeholder="Enter valve test pressure" />
//                   </Box>
//                 </Grid>

//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Valve Working Pressure</Typography>
//                     <TextField size="small" fullWidth type="text" onChange={handleChange}
//                       name="valve_working_pressure" value={data.valve_working_pressure} sx={inputSx} placeholder="Enter valve working pressure" />
//                   </Box>
//                 </Grid>

//               </Grid>
//             </Box>

//             {/* ── Section 3: Test & Certifications ── */}
//             <Box sx={subSectionHeaderSx}>
//               <PropaneTankIcon sx={{ fontSize: 18, color: "#fff" }} />
//               <Typography sx={sectionHeaderTitleSx}>Test & Certifications</Typography>
//             </Box>
//             <Box sx={formBodySx}>
//               <Grid container spacing={3}>

//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Peso Approval No</Typography>
//                     <TextField size="small" fullWidth type="text" onChange={handleChange}
//                       name="peso_approval_no" value={data.peso_approval_no} sx={inputSx} placeholder="Enter PESO approval number" />
//                   </Box>
//                 </Grid>

//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Peso Approval Date</Typography>
//                     <DatePicker format="DD/MM/YYYY"
//                       value={data.peso_approval_date ? dayjs(data.peso_approval_date) : dayjs()}
//                       onChange={(v) => handleChange({ target: { name: "peso_approval_date", value: v ? v.format("YYYY-MM-DD") : "" } })}
//                       slotProps={{ textField: { size: "small", fullWidth: true, sx: inputSx } }} />
//                   </Box>
//                 </Grid>

//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Peso Certificate Upload</Typography>
//                     <TextField size="small" fullWidth type="file" onChange={uploadFile}
//                       name="peso_certificate_upload" sx={inputSx}
//                       InputProps={{ inputProps: { accept: ".pdf,.jpg,.png" } }} />
//                     {pesoCertificateFile && (
//                       <Typography sx={{ fontSize: "11px", color: "#718096", mt: 0.5 }}>{pesoCertificateFile.name}</Typography>
//                     )}
//                   </Box>
//                 </Grid>

//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Hydrotest Certificate No</Typography>
//                     <TextField size="small" fullWidth type="text" onChange={handleChange}
//                       name="hydrotest_certificate_no" value={data.hydrotest_certificate_no} sx={inputSx} placeholder="Enter hydrotest certificate number" />
//                   </Box>
//                 </Grid>

//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Hydrotest Date</Typography>
//                     <DatePicker format="DD/MM/YYYY"
//                       value={data.hydrotest_date ? dayjs(data.hydrotest_date) : dayjs()}
//                       onChange={(v) => handleChange({ target: { name: "hydrotest_date", value: v ? v.format("YYYY-MM-DD") : "" } })}
//                       slotProps={{ textField: { size: "small", fullWidth: true, sx: inputSx } }} />
//                   </Box>
//                 </Grid>

//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Hydrotest Certificate Upload</Typography>
//                     <TextField size="small" fullWidth type="file" onChange={uploadHydrotestFile}
//                       name="hydrotest_certificate_upload" sx={inputSx}
//                       InputProps={{ inputProps: { accept: ".pdf,.jpg,.png" } }} />
//                     {hydrotestCertificateFile && (
//                       <Typography sx={{ fontSize: "11px", color: "#718096", mt: 0.5 }}>{hydrotestCertificateFile.name}</Typography>
//                     )}
//                   </Box>
//                 </Grid>

//               </Grid>
//             </Box>

//             {/* ── Section 4: Current Location ── */}
//             <Box sx={subSectionHeaderSx}>
//               <PropaneTankIcon sx={{ fontSize: 18, color: "#fff" }} />
//               <Typography sx={sectionHeaderTitleSx}>Current Location & Status</Typography>
//             </Box>
//             <Box sx={formBodySx}>
//               <Grid container spacing={3}>

//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Current Location</Typography>
//                     <TextField select size="small" fullWidth onChange={handleChange}
//                       name="current_location" value={data.current_location} sx={inputSx}>
//                       <MenuItem value=""><em>None</em></MenuItem>
//                       <MenuItem value="Customer" sx={{ fontSize: "13px" }}>Customer</MenuItem>
//                       <MenuItem value="Plant" sx={{ fontSize: "13px" }}>Plant</MenuItem>
//                       <MenuItem value="Depot" sx={{ fontSize: "13px" }}>Depot</MenuItem>
//                       <MenuItem value="Vehicle" sx={{ fontSize: "13px" }}>Vehicle</MenuItem>
//                     </TextField>
//                   </Box>
//                 </Grid>

//                 {data.current_location === "Depot" && (
//                   <Grid item xs={12} md={6}>
//                     <AutocompleteField
//                       label="Depot"
//                       options={depot}
//                       getOptionLabel={(o) => o?.depot_name || ""}
//                       value={depot?.find((i) => String(i.depot_id) === String(data.current_depot_id)) || null}
//                       onChange={(e, v) => handleChange({ target: { name: "current_depot_id", value: v ? v.depot_id : "" } })}
//                       isOptionEqualToValue={(o, v) => String(o.depot_id) === String(v.depot_id)}
//                     />
//                   </Grid>
//                 )}

//                 {data.current_location === "Plant" && (
//                   <Grid item xs={12} md={6}>
//                     <AutocompleteField
//                       label="Plant"
//                       options={plant}
//                       getOptionLabel={(o) => o?.plant_name || ""}
//                       value={plant?.find((i) => String(i.plant_id) === String(data.current_plant_id)) || null}
//                       onChange={(e, v) => handleChange({ target: { name: "current_plant_id", value: v ? v.plant_id : "" } })}
//                       isOptionEqualToValue={(o, v) => String(o.plant_id) === String(v.plant_id)}
//                     />
//                   </Grid>
//                 )}

//                 {data.current_location === "Customer" && (
//                   <Grid item xs={12} md={6}>
//                     <AutocompleteField
//                       label="Customer"
//                       options={customer}
//                       getOptionLabel={(o) => o?.cust_name || ""}
//                       value={customer?.find((i) => String(i.cust_id) === String(data.current_customer_id)) || null}
//                       onChange={(e, v) => handleChange({ target: { name: "current_customer_id", value: v ? v.cust_id : "" } })}
//                       isOptionEqualToValue={(o, v) => String(o.cust_id) === String(v.cust_id)}
//                     />
//                   </Grid>
//                 )}

//                 {data.current_location === "Vehicle" && (
//                   <Grid item xs={12} md={6}>
//                     <AutocompleteField
//                       label="Vehicle"
//                       options={vehicle}
//                       getOptionLabel={(o) => o?.vehicle_no || ""}
//                       value={vehicle?.find((i) => String(i.vehicle_id) === String(data.current_vehicle_id)) || null}
//                       onChange={(e, v) => handleChange({ target: { name: "current_vehicle_id", value: v ? v.vehicle_id : "" } })}
//                       isOptionEqualToValue={(o, v) => String(o.vehicle_id) === String(v.vehicle_id)}
//                     />
//                   </Grid>
//                 )}

//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Storage</Typography>
//                     <TextField select size="small" fullWidth onChange={handleChange}
//                       name="storage" value={data.storage} sx={inputSx}>
//                       <MenuItem value=""></MenuItem>
//                       <MenuItem value="Empty Store" sx={{ fontSize: "13px" }}>Empty Store</MenuItem>
//                       <MenuItem value="Fog Store" sx={{ fontSize: "13px" }}>Fog Store</MenuItem>
//                       <MenuItem value="Production Bay" sx={{ fontSize: "13px" }}>Production Bay</MenuItem>
//                       <MenuItem value="Inspection Bay" sx={{ fontSize: "13px" }}>Inspection Bay</MenuItem>
//                       <MenuItem value="Maintenance Yard" sx={{ fontSize: "13px" }}>Maintenance Yard</MenuItem>
//                     </TextField>
//                   </Box>
//                 </Grid>

//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Status</Typography>
//                     <TextField select size="small" fullWidth onChange={handleChange}
//                       name="status" value={data.status} sx={inputSx}>
//                       <MenuItem value=""></MenuItem>
//                       <MenuItem value="Empty" sx={{ fontSize: "13px" }}>Empty</MenuItem>
//                       <MenuItem value="Full" sx={{ fontSize: "13px" }}>Full</MenuItem>
//                     </TextField>
//                   </Box>
//                 </Grid>

//                 <Grid item xs={12} md={6}>
//                   <Box>
//                     <Typography sx={fieldLabelSx}>Note</Typography>
//                     <TextField select size="small" fullWidth onChange={handleChange}
//                       name="note" value={data.note} sx={inputSx}>
//                       <MenuItem value=""></MenuItem>
//                       <MenuItem value="OK" sx={{ fontSize: "13px" }}>OK</MenuItem>
//                       <MenuItem value="Not OK" sx={{ fontSize: "13px" }}>Not OK</MenuItem>
//                     </TextField>
//                   </Box>
//                 </Grid>

//               </Grid>
//             </Box>

//             {/* Form Footer */}
//             <Box sx={formFooterSx}>
//               <Button sx={cancelBtnSx} onClick={handleBack}>Cancel</Button>
//               <Button type="submit" sx={saveBtnSx}>
//                 <SaveIcon sx={{ fontSize: 18 }} />
//                 {editData ? "Update" : "Save"}
//               </Button>
//             </Box>
//           </Box>
//         </form>

//         <ReusableSnackbar
//           open={!!successMessage}
//           onClose={(event, reason) => { if (reason !== 'clickaway') setSuccessMessage(""); }}
//           message={successMessage}
//           autoHideDuration={2000}
//           vertical="top"
//           horizontal="right"
//         />
//       </Box>
//     </LocalizationProvider>
//   );
// };

// export default CylinderAdd;


import {
  Autocomplete,
  Box,
  Button,
  IconButton,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import AddIcon from '@mui/icons-material/Add';
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import SaveIcon from "@mui/icons-material/Save";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PropaneTankIcon from '@mui/icons-material/PropaneTank';
import { useDispatch } from "react-redux";
import dayjs from "dayjs";
import customerMasterService from "../../../services/masters/customerMaster.Service";
import depotMasterService from "../../../services/masters/depotMaster.Service";
import productMasterService from "../../../services/masters/productMaster.Service";
import uomMasterService from "../../../services/masters/uomMaster.Service";
import cylinderMasterService from "../../../services/masters/cylinderMaster.Service";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import plantmasterservices from "../../../services/masters/plantMaster.Service";
import vehiclemasterservices from "../../../services/masters/vehicleMaster.Service";

// ── Styles ─────────────────────────────────────────────────────────────────

const pageSx = {
  background: "#F4F7FB",
  minHeight: "100vh",
  padding: "20px 24px 40px",
  fontFamily: "'Inter', Arial, sans-serif",
};

const breadcrumbSx = {
  fontSize: "12px",
  color: "#718096",
  mb: 2,
  display: "flex",
  alignItems: "center",
  gap: "6px",
};

const pageHeaderSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  mb: 2.5,
};

const pageTitleSx = {
  fontSize: "16px",
  fontWeight: 700,
  color: "#000000",
  display: "flex",
  alignItems: "center",
  gap: "10px",
};

const backBtnSx = {
  display: "flex",
  alignItems: "center",
  gap: "6px",
  fontSize: "13px",
  fontWeight: 600,
  color: "#2B6CB0",
  padding: "7px 14px",
  border: "1.5px solid #2B6CB0",
  borderRadius: "7px",
  background: "#fff",
  cursor: "pointer",
  textTransform: "none",
  "&:hover": { background: "#E6F1FB" },
};

const formCardSx = {
  background: "#fff",

  border: "1px solid #E2E8F0",
  overflow: "hidden",
  mb: 3,
};

const sectionHeaderSx = {
  background: "#1C3A5E",
  padding: "12px 22px",
  display: "flex",
  alignItems: "center",
  gap: "10px",
};

const sectionHeaderTitleSx = {
  fontSize: "13px",
  fontWeight: 600,
  color: "#fff",
  letterSpacing: "0.3px",
};

const formBodySx = { padding: "22px 24px" };

const fieldLabelSx = {
  fontSize: "12px",
  fontWeight: 600,
  color: "#2063b6",
  mb: "4px",
  display: "flex",
  alignItems: "center",
  gap: "4px",
};

const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    fontSize: "13px",
    fontFamily: "'Inter', Arial, sans-serif",
    background: "#fafafa",
    height: "38px",
    "& fieldset": { borderColor: "#E2E8F0", borderWidth: "1.5px" },
    "&:hover fieldset": { borderColor: "#CBD5E0" },
    "&.Mui-focused fieldset": { borderColor: "#2B6CB0", borderWidth: "2px" },
    "&.Mui-focused": { background: "#fff" },
    "&.Mui-disabled": { background: "#F8FAFC" },
  },
  "& input": {
    color: "#1A202C",
    fontSize: "13px",
    fontFamily: "'Inter', Arial, sans-serif",
    "&::placeholder": { color: "#A0AEC0", opacity: 1 },
  },
  "& .MuiInputLabel-root": { display: "none" },
};

const readOnlyInputSx = {
  ...inputSx,
  "& .MuiOutlinedInput-root": {
    ...inputSx["& .MuiOutlinedInput-root"],
    background: "#f0f4f8",
  },
};

const formFooterSx = {
  padding: "18px 24px",
  background: "#F8FAFC",
  borderTop: "1px solid #E2E8F0",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: "10px",
};

const saveBtnSx = {
  display: "flex",
  alignItems: "center",
  gap: "7px",
  padding: "0 22px",
  height: "40px",
  background: "#4CAF50",
  color: "#fff",
  border: "none",
  fontSize: "14px",
  fontWeight: 600,
  textTransform: "none",
  fontFamily: "'Inter', Arial, sans-serif",
  "&:hover": { background: "#028b19", transform: "translateY(-1px)" },
  "&:active": { transform: "translateY(0)" },
  "&.Mui-disabled": { background: "#94a3b8", color: "#fff" },
  transition: "all 0.15s ease",
};

const cancelBtnSx = {
  display: "flex",
  alignItems: "center",
  gap: "7px",
  padding: "0 22px",
  height: "40px",
  background: "#E53E3E",
  color: "#ffffff",
  border: "none",
  "&:hover": { background: "#971f16", transform: "translateY(-1px)" },
  fontSize: "14px",
  fontWeight: 600,
  borderRadius: "8px",
};

const addIconBtnSx = {
  color: "#2B6CB0",
  border: "1px solid #2B6CB0",
  borderRadius: "6px",
  p: "5px",
  ml: 0.5,
  flexShrink: 0,
};

// ─────────────────────────────────────────────────────────────────────────────

const CylinderAdd = () => {
  const { handleSubmit } = useForm({ mode: 'onSubmit' });
  const dispatch = useDispatch();
  const login_details = sessionStorage.getItem('loginUser');
  const userD = JSON.parse(login_details);
  const userInfo = userD.result.userInfo;
  const urlLocation = useLocation();
  const editInfo = urlLocation.state;
  const editData = editInfo && editInfo;

  const getFileNameFromUrl = (url) => {
    try {
      const path = new URL(url).pathname;
      return path.substring(path.lastIndexOf("/") + 1);
    } catch (error) {
      return "";
    }
  };

  const [pesoCertificateFile, setPesoCertificateFile] = useState(
    editData && editData.peso_certificate_upload
      ? { name: getFileNameFromUrl(editData.peso_certificate_upload) } : null
  );
  const [hydrotestCertificateFile, setHydrotestCertificateFile] = useState(
    editData && editData.hydrotest_certificate_upload
      ? { name: getFileNameFromUrl(editData.hydrotest_certificate_upload) } : null
  );

  const [data, setData] = useState({
    cylinder_no: editData ? editData.cylinder_no : "",
    owner: editData ? editData.owner : "",
    prod_id: editData ? editData.prod_id : null,
    plant_id: editData ? editData.plant_id : "",
    depot_id: editData ? editData.depot_id : "",
    prod_code: editData ? editData.prod_code : "",
    prod_description: editData ? editData.prod_description : "",
    cyl_capacity: editData ? editData.cyl_capacity : "",
    uom: editData ? editData.uom : "",
    purchase_date: editData?.purchase_date && !isNaN(new Date(editData.purchase_date))
      ? new Date(editData.purchase_date).toISOString().split("T")[0]
      : new Date().toISOString().split("T")[0],
    tare_wt: editData ? editData.tare_wt : "",
    water_capacity: editData ? editData.water_capacity : "",
    test_pressure: editData ? editData.test_pressure : "",
    working_pressure: editData ? editData.working_pressure : "",
    cylinder_manufacturer: editData ? editData.cylinder_manufacturer : "",
    tag_no: editData ? editData.tag_no : "",
    cylinder_manufacturing_code: editData ? editData.cylinder_manufacturing_code : "",
    cylinder_manufacturing_date: editData?.cylinder_manufacturing_date && !isNaN(new Date(editData.cylinder_manufacturing_date))
      ? new Date(editData.cylinder_manufacturing_date).toISOString().split("T")[0]
      : new Date().toISOString().split("T")[0],
    cylinder_purchase_date: editData?.cylinder_purchase_date && !isNaN(new Date(editData.cylinder_purchase_date))
      ? new Date(editData.cylinder_purchase_date).toISOString().split("T")[0]
      : new Date().toISOString().split("T")[0],
    valve_type: editData ? editData.valve_type : "",
    valve_manufacturer: editData ? editData.valve_manufacturer : "",
    valve_manufacturing_code: editData ? editData.valve_manufacturing_code : "",
    valve_test_pressure: editData ? editData.valve_test_pressure : "",
    valve_working_pressure: editData ? editData.valve_working_pressure : "",
    peso_approval_no: editData ? editData.peso_approval_no : "",
    peso_approval_date: editData?.peso_approval_date && !isNaN(new Date(editData.peso_approval_date))
      ? new Date(editData.peso_approval_date).toISOString().split("T")[0]
      : new Date().toISOString().split("T")[0],
    peso_certificate_upload: editData ? editData.peso_certificate_upload : "",
    hydrotest_certificate_no: editData ? editData.hydrotest_certificate_no : "",
    hydrotest_date: editData?.hydrotest_date && !isNaN(new Date(editData.hydrotest_date))
      ? new Date(editData.hydrotest_date).toISOString().split("T")[0]
      : new Date().toISOString().split("T")[0],
    hydrotest_certificate_upload: editData ? editData.hydrotest_certificate_upload : "",
    current_location: editData ? editData.current_location : "",
    current_plant_id: editData ? editData.current_plant_id : "",
    current_vehicle_id: editData ? editData.current_vehicle_id : "",
    current_depot_id: editData ? editData.current_depot_id : "",
    cust_id: editData ? editData.customer_id : "",
    current_customer_id: editData ? editData.current_customer_id : "",
    status: editData ? editData.status : "",
  level: editData ? (editData.level ?? editData.note ?? "") : "",
result: editData ? editData.result ?? null : null,
remark: editData ? editData.remark ?? null : null,
note: editData ? (editData.level ?? editData.note ?? "") : "",
    storage: editData ? editData.storage : "",
  });

  const [successMessage, setSuccessMessage] = useState(null);
  const [customer, setCustomer] = useState([]);
  const [depot, setDepot] = useState([]);
  const [product, setProduct] = useState([]);
  const [uom, setUOM] = useState([]);
  const [plant, setPlant] = useState([]);
  const [vehicle, setvehicle] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const [customerData, depotData, productData, uomData, plantdata, vehicleData] = await Promise.all([
          customerMasterService.getCustomerList({ page: 0, size: 999, searchKey: "" }),
          depotMasterService.getDepotList({ page: 0, size: 999, searchKey: "" }),
          productMasterService.getProductList({ page: 0, size: 999, searchKey: "" }),
          uomMasterService.getUOMList({ page: 0, size: 999, searchKey: "" }),
          plantmasterservices.getPlantList({ page: 0, size: 999, searchKey: "" }),
          vehiclemasterservices.getVehicleList({ page: 0, size: 999, searchKey: "" }),
        ]);
        setCustomer(customerData);
        setDepot(depotData);
        setProduct(productData);
        setUOM(uomData);
        setPlant(plantdata);
        setvehicle(vehicleData);
      } catch (error) {
        console.error("Data fetching failed", error);
      }
    }
    fetchData();
  }, []);

  useEffect(() => {
    let objectUrlPo, objectUrlQuotation;
    if (pesoCertificateFile instanceof File) objectUrlPo = URL.createObjectURL(pesoCertificateFile);
    if (hydrotestCertificateFile instanceof File) objectUrlQuotation = URL.createObjectURL(hydrotestCertificateFile);
    return () => {
      if (objectUrlPo) URL.revokeObjectURL(objectUrlPo);
      if (objectUrlQuotation) URL.revokeObjectURL(objectUrlQuotation);
    };
  }, [pesoCertificateFile, hydrotestCertificateFile]);

  const handleChange = ({ target }) => {
    const { name, value } = target;
    if (name === "prod_code") {
      const selectedProduct = product.find((p) => p.prod_code === value);
      setData({ ...data, prod_code: value, prod_id: selectedProduct?.prod_id || "", prod_description: selectedProduct?.prod_description || "" });
    } else {
      setData({ ...data, [name]: value });
    }
  };

  const uploadFile = (e) => {
    const file = e.target.files[0];
    setPesoCertificateFile(file);
    setData((prev) => ({ ...prev, peso_certificate_upload: file ? file.name : "" }));
  };

  const uploadHydrotestFile = (e) => {
    const file = e.target.files[0];
    setHydrotestCertificateFile(file);
    setData((prev) => ({ ...prev, hydrotest_certificate_upload: file ? file.name : "" }));
  };

  const navigate = useNavigate();
  const handleBack = () => navigate(-1);
  const handleNavigate = (path) => navigate(path);

  const onSubmit = async () => {
    if (!data.prod_id || !data.prod_code) {
      setSuccessMessage("Error: Please select a valid Product Code from the dropdown list");
      return;
    }
    const cylinderData = {
      cylinder_no: data.cylinder_no, owner: data.owner, prod_id: data.prod_id,
      plant_id: data.plant_id, prod_code: data.prod_code, prod_description: data.prod_description,
      cyl_capacity: data.cyl_capacity, uom: data.uom, purchase_date: data.purchase_date,
      tare_wt: data.tare_wt, water_capacity: data.water_capacity, test_pressure: data.test_pressure,
      working_pressure: data.working_pressure, cylinder_manufacturer: data.cylinder_manufacturer,
      tag_no: data.tag_no, cylinder_manufacturing_code: data.cylinder_manufacturing_code,
      cylinder_manufacturing_date: data.cylinder_manufacturing_date,
      cylinder_purchase_date: data.cylinder_purchase_date, valve_type: data.valve_type,
      valve_manufacturer: data.valve_manufacturer, valve_manufacturing_code: data.valve_manufacturing_code,
      valve_test_pressure: data.valve_test_pressure, valve_working_pressure: data.valve_working_pressure,
      peso_approval_no: data.peso_approval_no, peso_approval_date: data.peso_approval_date,
      hydrotest_certificate_no: data.hydrotest_certificate_no, hydrotest_date: data.hydrotest_date,
      current_location: data.current_location, current_plant_id: data.current_plant_id,
      current_vehicle_id: data.current_vehicle_id, current_depot_id: data.current_depot_id,
      current_customer_id: data.current_customer_id, customer_id: data.cust_id,
      status: data.status, note: data.note, storage: data.storage,
      modified_at: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      modified_by: editData ? userInfo.user_id : null,
      created_at: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      created_by: editData ? editData.created_by : userInfo.user_id,
      changedUpdatedValue: "edit",
      cyl_id: editData ? editData.cyl_id : "",
    };
    const formData = new FormData();
    formData.append("cylinderData", JSON.stringify(cylinderData));
    if (pesoCertificateFile instanceof File) formData.append("peso_certificate_upload", pesoCertificateFile);
    else if (editData?.peso_certificate_upload) formData.append("peso_certificate_upload", editData.peso_certificate_upload);
    if (hydrotestCertificateFile instanceof File) formData.append("hydrotest_certificate_upload", hydrotestCertificateFile);
    else if (editData?.hydrotest_certificate_upload) formData.append("hydrotest_certificate_upload", editData.hydrotest_certificate_upload);
    try {
      if (editData) {
        await cylinderMasterService.editDeleteCylinder(formData);
        setSuccessMessage("Updated successfully");
      } else {
        await cylinderMasterService.addCylinder(formData);
        setSuccessMessage("Added successfully");
      }
      setTimeout(() => { navigate(-1); setSuccessMessage(null); }, 1000);
    } catch (error) {
      setSuccessMessage(`Error: ${error.message || "An error occurred"}`);
    }
  };

  const AutocompleteField = ({ label, required, options, getOptionLabel, value, onChange, isOptionEqualToValue, onAddClick, renderOption }) => (
    <Box>
      <Typography sx={fieldLabelSx}>
        {label} {required && <span style={{ color: "#E53E3E" }}>*</span>}
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
        <Autocomplete
          options={options || []}
          fullWidth
          getOptionLabel={getOptionLabel}
          value={value}
          onChange={onChange}
          renderOption={renderOption || ((props, option) => (
            <MenuItem {...props} sx={{ fontSize: "13px" }}>{getOptionLabel(option)}</MenuItem>
          ))}
          renderInput={(params) => (
            <TextField {...params} size="small" fullWidth sx={inputSx} required={required} />
          )}
          isOptionEqualToValue={isOptionEqualToValue}
        />
        {onAddClick && (
          <IconButton size="small" onClick={onAddClick} sx={addIconBtnSx}>
            <AddIcon fontSize="small" />
          </IconButton>
        )}
      </Box>
    </Box>
  );

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={pageSx}>

        {/* Breadcrumb */}
        <Box sx={breadcrumbSx}>
          <span>Dashboard</span> / <span style={{ color: "#2B6CB0", fontWeight: 600 }}>Cylinder</span>
        </Box>

        {/* Page Header */}
        <Box sx={pageHeaderSx}>
          <Box sx={pageTitleSx}>
            <PropaneTankIcon sx={{ fontSize: 20, color: "#1C3A5E" }} />
            {editData ? "UPDATE" : "ADD"} CYLINDER
          </Box>
          <Button onClick={handleBack} sx={backBtnSx}>
            <ArrowBackIcon sx={{ fontSize: 16 }} /> Back
          </Button>
        </Box>

        <form onSubmit={handleSubmit(onSubmit)}>

          {/* ── Single merged card ── */}
          <Box sx={formCardSx}>

            {/* Single heading */}
            <Box sx={sectionHeaderSx}>
              <PropaneTankIcon sx={{ fontSize: 18, color: "#fff" }} />
              <Typography sx={sectionHeaderTitleSx}>Cylinder Details</Typography>
            </Box>

            {/* All fields in one flat body */}
            <Box sx={formBodySx}>
              <Grid container spacing={3}>

                {/* Cylinder No */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>Cylinder No <span style={{ color: "#E53E3E" }}>*</span></Typography>
                    <TextField size="small" fullWidth type="text" onChange={handleChange}
                      name="cylinder_no" value={data.cylinder_no} required sx={inputSx} placeholder="Enter cylinder number" />
                  </Box>
                </Grid>

                {/* Cylinder Tag */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>Cylinder Tag</Typography>
                    <TextField size="small" fullWidth type="text" onChange={handleChange}
                      name="tag_no" value={data.tag_no} sx={inputSx} placeholder="Enter tag number" />
                  </Box>
                </Grid>

                {/* Owner */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>Owner <span style={{ color: "#E53E3E" }}>*</span></Typography>
                    <TextField select size="small" fullWidth required onChange={handleChange}
                      name="owner" value={data.owner} sx={inputSx}>
                      <MenuItem value="TGPL" sx={{ fontSize: "13px" }}>TGPL</MenuItem>
                      <MenuItem value="Customer" sx={{ fontSize: "13px" }}>Customer</MenuItem>
                    </TextField>
                  </Box>
                </Grid>

                {/* Customer Name (conditional) */}
                {data.owner === "Customer" && (
                  <Grid item xs={12} md={6}>
                    <Box>
                      <Typography sx={fieldLabelSx}>Customer Name</Typography>
                      <TextField select size="small" fullWidth onChange={handleChange}
                        name="cust_id" value={data.cust_id || ""} sx={inputSx}>
                        <MenuItem value=""><em>Select Customer</em></MenuItem>
                        {customer.map((c) => (
                          <MenuItem key={c.cust_id} value={c.cust_id} sx={{ fontSize: "13px" }}>{c.cust_name}</MenuItem>
                        ))}
                      </TextField>
                    </Box>
                  </Grid>
                )}

                {/* Plant */}
                <Grid item xs={12} md={6}>
                  <AutocompleteField
                    label="Plant"
                    options={plant}
                    getOptionLabel={(o) => o?.plant_name || ""}
                    value={plant?.find((i) => String(i.plant_id) === String(data.plant_id)) || null}
                    onChange={(e, v) => handleChange({ target: { name: "plant_id", value: v ? v.plant_id : "" } })}
                    isOptionEqualToValue={(o, v) => String(o.plant_id) === String(v.plant_id)}
                    onAddClick={() => handleNavigate('/masters/Addplant')}
                  />
                </Grid>

                {/* Product Code */}
                <Grid item xs={12} md={6}>
                  <AutocompleteField
                    label="Product Code" required
                    options={product}
                    getOptionLabel={(o) => o?.prod_code || ""}
                    value={product?.find((p) => p.prod_code === data.prod_code) || null}
                    onChange={(e, v) => handleChange({ target: { name: "prod_code", value: v ? v.prod_code : "" } })}
                    isOptionEqualToValue={(o, v) => o.prod_code === v.prod_code}
                  />
                </Grid>

                {/* Product Description */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>Product Description</Typography>
                    <TextField size="small" fullWidth value={data.prod_description}
                      sx={readOnlyInputSx} InputProps={{ readOnly: true }} placeholder="Auto-filled from product code" />
                  </Box>
                </Grid>

                {/* UOM */}
                <Grid item xs={12} md={6}>
                  <AutocompleteField
                    label="UOM"
                    options={uom}
                    getOptionLabel={(o) => o?.uom || ""}
                    value={uom?.find((u) => u.uom === data.uom) || null}
                    onChange={(e, v) => handleChange({ target: { name: "uom", value: v ? v.uom : "" } })}
                    isOptionEqualToValue={(o, v) => o.uom === v.uom}
                    onAddClick={() => handleNavigate('/masters/add-uom')}
                  />
                </Grid>

                {/* Cylinder Capacity */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>Cylinder Capacity (Kg)</Typography>
                    <TextField size="small" fullWidth type="text" onChange={handleChange}
                      name="cyl_capacity" value={data.cyl_capacity} sx={inputSx} placeholder="Enter capacity" />
                  </Box>
                </Grid>

                {/* Tare Wt */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>Tare Wt</Typography>
                    <TextField size="small" fullWidth type="text" onChange={handleChange}
                      name="tare_wt" value={data.tare_wt} sx={inputSx} placeholder="Enter tare weight" />
                  </Box>
                </Grid>

                {/* Water Capacity */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>Water Capacity</Typography>
                    <TextField size="small" fullWidth type="text" onChange={handleChange}
                      name="water_capacity" value={data.water_capacity} sx={inputSx} placeholder="Enter water capacity" />
                  </Box>
                </Grid>

                {/* Test Pressure */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>Test Pressure</Typography>
                    <TextField size="small" fullWidth type="text" onChange={handleChange}
                      name="test_pressure" value={data.test_pressure} sx={inputSx} placeholder="Enter test pressure" />
                  </Box>
                </Grid>

                {/* Working Pressure */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>Working Pressure</Typography>
                    <TextField size="small" fullWidth type="text" onChange={handleChange}
                      name="working_pressure" value={data.working_pressure} sx={inputSx} placeholder="Enter working pressure" />
                  </Box>
                </Grid>

                {/* Cylinder Manufacturer */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>Cylinder Manufacturer</Typography>
                    <TextField size="small" fullWidth type="text" onChange={handleChange}
                      name="cylinder_manufacturer" value={data.cylinder_manufacturer} sx={inputSx} placeholder="Enter manufacturer" />
                  </Box>
                </Grid>

                {/* Cylinder Manufacturing Code */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>Cylinder Manufacturing Code <span style={{ color: "#E53E3E" }}>*</span></Typography>
                    <TextField size="small" fullWidth type="text" onChange={handleChange}
                      name="cylinder_manufacturing_code" value={data.cylinder_manufacturing_code} sx={inputSx} placeholder="Enter manufacturing code" />
                  </Box>
                </Grid>

                {/* Cylinder Manufacturing Date */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>Cylinder Manufacturing Date</Typography>
                    <DatePicker format="DD/MM/YYYY"
                      value={data.cylinder_manufacturing_date ? dayjs(data.cylinder_manufacturing_date) : dayjs()}
                      onChange={(v) => handleChange({ target: { name: "cylinder_manufacturing_date", value: v ? v.format("YYYY-MM-DD") : "" } })}
                      slotProps={{ textField: { size: "small", fullWidth: true, sx: inputSx } }} />
                  </Box>
                </Grid>

                {/* Cylinder Purchase Date */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>Cylinder Purchase Date</Typography>
                    <DatePicker format="DD/MM/YYYY"
                      value={data.cylinder_purchase_date ? dayjs(data.cylinder_purchase_date) : null}
                      onChange={(v) => handleChange({ target: { name: "cylinder_purchase_date", value: v ? v.format("YYYY-MM-DD") : "" } })}
                      slotProps={{ textField: { size: "small", fullWidth: true, sx: inputSx } }} />
                  </Box>
                </Grid>

                {/* Valve Type */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>Valve Type</Typography>
                    <TextField size="small" fullWidth type="text" onChange={handleChange}
                      name="valve_type" value={data.valve_type} sx={inputSx} placeholder="Enter valve type" />
                  </Box>
                </Grid>

                {/* Valve Manufacturer */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>Valve Manufacturer</Typography>
                    <TextField size="small" fullWidth type="text" onChange={handleChange}
                      name="valve_manufacturer" value={data.valve_manufacturer} sx={inputSx} placeholder="Enter valve manufacturer" />
                  </Box>
                </Grid>

                {/* Valve Manufacturing Code */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>Valve Manufacturing Code</Typography>
                    <TextField size="small" fullWidth type="text" onChange={handleChange}
                      name="valve_manufacturing_code" value={data.valve_manufacturing_code} sx={inputSx} placeholder="Enter valve manufacturing code" />
                  </Box>
                </Grid>

                {/* Valve Test Pressure */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>Valve Test Pressure</Typography>
                    <TextField size="small" fullWidth type="text" onChange={handleChange}
                      name="valve_test_pressure" value={data.valve_test_pressure} sx={inputSx} placeholder="Enter valve test pressure" />
                  </Box>
                </Grid>

                {/* Valve Working Pressure */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>Valve Working Pressure</Typography>
                    <TextField size="small" fullWidth type="text" onChange={handleChange}
                      name="valve_working_pressure" value={data.valve_working_pressure} sx={inputSx} placeholder="Enter valve working pressure" />
                  </Box>
                </Grid>

                {/* PESO Approval No */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>Peso Approval No</Typography>
                    <TextField size="small" fullWidth type="text" onChange={handleChange}
                      name="peso_approval_no" value={data.peso_approval_no} sx={inputSx} placeholder="Enter PESO approval number" />
                  </Box>
                </Grid>

                {/* PESO Approval Date */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>Peso Approval Date</Typography>
                    <DatePicker format="DD/MM/YYYY"
                      value={data.peso_approval_date ? dayjs(data.peso_approval_date) : dayjs()}
                      onChange={(v) => handleChange({ target: { name: "peso_approval_date", value: v ? v.format("YYYY-MM-DD") : "" } })}
                      slotProps={{ textField: { size: "small", fullWidth: true, sx: inputSx } }} />
                  </Box>
                </Grid>

                {/* PESO Certificate Upload */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>Peso Certificate Upload</Typography>
                    <TextField size="small" fullWidth type="file" onChange={uploadFile}
                      name="peso_certificate_upload" sx={inputSx}
                      InputProps={{ inputProps: { accept: ".pdf,.jpg,.png" } }} />
                    {pesoCertificateFile && (
                      <Typography sx={{ fontSize: "11px", color: "#718096", mt: 0.5 }}>{pesoCertificateFile.name}</Typography>
                    )}
                  </Box>
                </Grid>

                {/* Hydrotest Certificate No */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>Hydrotest Certificate No</Typography>
                    <TextField size="small" fullWidth type="text" onChange={handleChange}
                      name="hydrotest_certificate_no" value={data.hydrotest_certificate_no} sx={inputSx} placeholder="Enter hydrotest certificate number" />
                  </Box>
                </Grid>

                {/* Hydrotest Date */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>Hydrotest Date</Typography>
                    <DatePicker format="DD/MM/YYYY"
                      value={data.hydrotest_date ? dayjs(data.hydrotest_date) : dayjs()}
                      onChange={(v) => handleChange({ target: { name: "hydrotest_date", value: v ? v.format("YYYY-MM-DD") : "" } })}
                      slotProps={{ textField: { size: "small", fullWidth: true, sx: inputSx } }} />
                  </Box>
                </Grid>

                {/* Hydrotest Certificate Upload */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>Hydrotest Certificate Upload</Typography>
                    <TextField size="small" fullWidth type="file" onChange={uploadHydrotestFile}
                      name="hydrotest_certificate_upload" sx={inputSx}
                      InputProps={{ inputProps: { accept: ".pdf,.jpg,.png" } }} />
                    {hydrotestCertificateFile && (
                      <Typography sx={{ fontSize: "11px", color: "#718096", mt: 0.5 }}>{hydrotestCertificateFile.name}</Typography>
                    )}
                  </Box>
                </Grid>

                {/* Current Location */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>Current Location</Typography>
                    <TextField select size="small" fullWidth onChange={handleChange}
                      name="current_location" value={data.current_location} sx={inputSx}>
                      <MenuItem value=""><em>None</em></MenuItem>
                      <MenuItem value="Customer" sx={{ fontSize: "13px" }}>Customer</MenuItem>
                      <MenuItem value="Plant" sx={{ fontSize: "13px" }}>Plant</MenuItem>
                      <MenuItem value="Depot" sx={{ fontSize: "13px" }}>Depot</MenuItem>
                      <MenuItem value="Vehicle" sx={{ fontSize: "13px" }}>Vehicle</MenuItem>
                    </TextField>
                  </Box>
                </Grid>

                {/* Conditional: Depot */}
                {data.current_location === "Depot" && (
                  <Grid item xs={12} md={6}>
                    <AutocompleteField
                      label="Depot"
                      options={depot}
                      getOptionLabel={(o) => o?.depot_name || ""}
                      value={depot?.find((i) => String(i.depot_id) === String(data.current_depot_id)) || null}
                      onChange={(e, v) => handleChange({ target: { name: "current_depot_id", value: v ? v.depot_id : "" } })}
                      isOptionEqualToValue={(o, v) => String(o.depot_id) === String(v.depot_id)}
                    />
                  </Grid>
                )}

                {/* Conditional: Plant */}
                {data.current_location === "Plant" && (
                  <Grid item xs={12} md={6}>
                    <AutocompleteField
                      label="Plant"
                      options={plant}
                      getOptionLabel={(o) => o?.plant_name || ""}
                      value={plant?.find((i) => String(i.plant_id) === String(data.current_plant_id)) || null}
                      onChange={(e, v) => handleChange({ target: { name: "current_plant_id", value: v ? v.plant_id : "" } })}
                      isOptionEqualToValue={(o, v) => String(o.plant_id) === String(v.plant_id)}
                    />
                  </Grid>
                )}

                {/* Conditional: Customer */}
                {data.current_location === "Customer" && (
                  <Grid item xs={12} md={6}>
                    <AutocompleteField
                      label="Customer"
                      options={customer}
                      getOptionLabel={(o) => o?.cust_name || ""}
                      value={customer?.find((i) => String(i.cust_id) === String(data.current_customer_id)) || null}
                      onChange={(e, v) => handleChange({ target: { name: "current_customer_id", value: v ? v.cust_id : "" } })}
                      isOptionEqualToValue={(o, v) => String(o.cust_id) === String(v.cust_id)}
                    />
                  </Grid>
                )}

                {/* Conditional: Vehicle */}
                {data.current_location === "Vehicle" && (
                  <Grid item xs={12} md={6}>
                    <AutocompleteField
                      label="Vehicle"
                      options={vehicle}
                      getOptionLabel={(o) => o?.vehicle_no || ""}
                      value={vehicle?.find((i) => String(i.vehicle_id) === String(data.current_vehicle_id)) || null}
                      onChange={(e, v) => handleChange({ target: { name: "current_vehicle_id", value: v ? v.vehicle_id : "" } })}
                      isOptionEqualToValue={(o, v) => String(o.vehicle_id) === String(v.vehicle_id)}
                    />
                  </Grid>
                )}

                {/* Storage */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>Storage</Typography>
                    <TextField select size="small" fullWidth onChange={handleChange}
                      name="storage" value={data.storage} sx={inputSx}>
                      <MenuItem value=""></MenuItem>
                      <MenuItem value="Empty Store" sx={{ fontSize: "13px" }}>Empty Store</MenuItem>
                      <MenuItem value="Fog Store" sx={{ fontSize: "13px" }}>FG Store</MenuItem>
                      <MenuItem value="Production Bay" sx={{ fontSize: "13px" }}>Production Bay</MenuItem>
                      <MenuItem value="Inspection Bay" sx={{ fontSize: "13px" }}>Inspection Bay</MenuItem>
                      <MenuItem value="Maintenance Yard" sx={{ fontSize: "13px" }}>Maintenance Yard</MenuItem>
                    </TextField>
                  </Box>
                </Grid>

                {/* Status */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>Status</Typography>
                    <TextField select size="small" fullWidth onChange={handleChange}
                      name="status" value={data.status} sx={inputSx}>
                      <MenuItem value=""></MenuItem>
                      <MenuItem value="Empty" sx={{ fontSize: "13px" }}>Empty</MenuItem>
                      <MenuItem value="Full" sx={{ fontSize: "13px" }}>Full</MenuItem>
                    </TextField>
                  </Box>
                </Grid>

                {/* Note */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>Note</Typography>
                    <TextField select size="small" fullWidth onChange={handleChange}
                      name="note" value={data.note} sx={inputSx}>
                      <MenuItem value=""></MenuItem>
                      <MenuItem value="OK" sx={{ fontSize: "13px" }}>OK</MenuItem>
                      <MenuItem value="Not OK" sx={{ fontSize: "13px" }}>Not OK</MenuItem>
                    </TextField>
                  </Box>
                </Grid>

              </Grid>
            </Box>

            {/* Form Footer */}
            <Box sx={formFooterSx}>
              <Button sx={cancelBtnSx} onClick={handleBack}>Cancel</Button>
              <Button type="submit" sx={saveBtnSx}>
                <SaveIcon sx={{ fontSize: 18 }} />
                {editData ? "Update" : "Save"}
              </Button>
            </Box>

          </Box>
        </form>

        <ReusableSnackbar
          open={!!successMessage}
          onClose={(event, reason) => { if (reason !== 'clickaway') setSuccessMessage(""); }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />
      </Box>
    </LocalizationProvider>
  );
};

export default CylinderAdd;